// This file is automatically generated.
// Do not edit this file manually, use the script createLocales.js!

/* eslint-disable quotes */
/* eslint-disable indent */

export default {
  "__vendor__": "mtf",
  "devise": {
    "failure": {
      "bad_request": "Dati errati. Si prega di ricominciare.",
      "already_registered": "Questa email è gia in uso. Vi abbiamo inviato una email con un link di attivazione del vostro account al vostro indirizzo mail. Verificate le vostre mail e attivate l'account.",
      "timeout": "Sessione scaduta, accedete nuovamente per continuare.",
      "forbidden": "Vietato",
      "invalid": "Indirizzo email o password non validi.",
      "username": {
        "already_in_use": "Questo nome utente è già in uso!"
      },
      "email": {
        "already_in_use": "Questa email è gia in uso."
      },
      "already_activated": "Se la vostra email è gia nella nostra banca dati, riceverete una email con istruzioni per recuperare il vostro account entro pochi minuti."
    },
    "mailer": {
      "confirmation_instructions": {
        "subject": "Istruzioni per la conferma"
      },
      "reset_password_instructions": {
        "subject": "Istruzioni per reimpostare la password"
      }
    },
    "confirmations": {
      "send_instructions": "Riceverete un messaggio e-mail con le istruzioni per confermare il vostro account entro qualche minuto.",
      "send_instructions_paranoid": "Se vi siete registrati su VBus.net, riceverete in pochi minuti una mail di conferma dell’avvenuta registrazione. Controllate la vostra casella di posta."
    },
    "passwords": {
      "updated_not_active": "La vostra password è stata cambiata.",
      "send_paranoid_instructions": "Se la vostra e-mail esiste nel nostro database, riceverete un messaggio email contentente un link per il ripristino della password."
    },
    "registrations": {
      "destroyed": "Arrivederci! L'account è stato cancellato. Speriamo di rivederci presto."
    }
  },
  "general": {
    "welcome": "Benvenuti",
    "yourProAccount": "Il vostro acceso PRO ",
    "hello": "Ciao",
    "greetings": "I migliori saluti",
    "vbusnetTeam": "La vostra equipe VBus.net",
    "errorInvalidCharacters": "Caratteri non validi",
    "emailUnsubscribed": " Il vostro indirizzo e-mail è stato eliminato con successo.",
    "emailAlreadyUnsubscribed": " Il vostro indirizzo e-mail è già stato eliminato!",
    "newDevice": "Nuovo apparecchio",
    "isFriend": "Condividere",
    "backup": {
      "error": {
        "file": "File di backup danneggiato o non valido!",
        "fileMatchSystem": "Il file di backup non corrisponde al sistema selezionato."
      },
      "choose": {
        "file": "Selezionare un backup"
      },
      "restore": "Ripristinare backup",
      "successful": "I vostri i dati sono stati ripristinati con successo.",
      "name": "Backup (copia di riserva )",
      "create": "Creare backup",
      "text1": "Qui troverete una panoramica dei vostri dati. Selezionate i punti che desiderate salvare. Se si seleziona un sistema in diretta, un diagramma o scaricare, tutti i filtri e le immagini corrispondenti verranno salvate.",
      "file": "File di backup ",
      "text2": "Tutti i dati di backup sono elencati di seguito. È possibile ripristinare tutti i dati o i dati selezionati. Se si sceglie un sistema in diretta, un diagramma o di scaricare, i corrispondenti filtri e le immagini saranno ripristinate. ",
      "fileType": "Il file deve essere un file di backup VBus.net valido!",
      "text3": "I vostri dati in diretta sono stati cambiati dopo l'ultimo backup! Questo può accadere se sono stati collegati nuovi apparecchi o se sono stati rimossi o ricollegati. Si prega di notare che dopo il ripristino, le impostazioni del filtro potrebbero non essere corrette.",
      "visualization": "Visualizzazione dei dati di backup"
    },
    "days": "Giorni",
    "entryNotFound": "Nessun elemento è stato trovato.",
    "allValues": "Tutti i valori",
    "unknown": "Sconosciuto",
    "from": "Da",
    "to": "Fino a",
    "customRange": "Intervallo scelto da voi",
    "name": "Nome",
    "unit": "Unità",
    "color": "Colore",
    "format": "Formato",
    "errorTryAgain": "Siamo spiacenti, si è verificato un errore. Si prega di riprovare più tardi... ",
    "interestedInProducts": "Grazie per l’interesse dimostrato nei confronti dei nostri prodotti.",
    "ok": "OK",
    "currentAccount": "Accesso attuale",
    "newInvalidDate": "Nuova data di scadenza",
    "KontaktformularKenntnis": "Ho letto l'informativa della privacy sugli __PRIVACY_POLICY__. Accetto la raccolta e l'archiviazione delle mie informazioni e dati per rispondere alla mia richiesta",
    "interval": "Intervallo",
    "minute": "Minuti",
    "minutes": "Minuti",
    "monday": "Lunedì",
    "tuesday": "Martedì",
    "wednesday": "Mercoledì",
    "thursday": "Giovedì",
    "friday": "Venerdì",
    "saturday": "Sabato",
    "sunday": "Domenica",
    "displayValue": "Valore visualizzato",
    "conversions": "Conversione",
    "add": "aggiungere",
    "displayUnit": "Schermo di visualizzazione",
    "none": "Nessuna",
    "close": "Chiudere",
    "apply": "Impiegare",
    "note": "Note",
    "deleteIrrevocably": "I dati saranno irrevocabilmente cancellati!",
    "delete": "Cancellare",
    "errors": "Errori",
    "noErrors": "Nessun errore",
    "error": "Errore",
    "deleted": "Cancellato!",
    "entryDeleted": "L’input è stato cancellato.",
    "save": "Salvare",
    "edit": "Modificare",
    "status": "Stato",
    "cancel": "Cancellare",
    "weiter": "Avanti",
    "yesDelete": "Sì, cancellare",
    "no": "No",
    "configurationDeleted": "La configurazione è stata cancellata.",
    "selectAll": "Seleziona tutto",
    "unselectAll": "Deseleziona tutto",
    "download": "Download",
    "prefix": "Prefisso",
    "subscription": "Accesso",
    "information": "Informazione",
    "passwordCurrent": "Password attuale",
    "languageForEmail": "Lingua (E-mails)",
    "defaultUnits": "Le unità standard",
    "dateFormat": "Formato della data",
    "myPersonalSettings": "I miei dati personali",
    "changeYourPassword": "Cambiare la password",
    "login": "Connettersi",
    "newPassword": "Nuova password",
    "passwordLength": "deve contenere almeno 6 caratteri",
    "passwordConfirmNewPassword": "Confermare nuova password",
    "forgotYourPassword": "Password dimenticata ?",
    "passwordDifferent": "Le due password non coincidono tra loro!",
    "password": "Password",
    "nameResolRegler": "Centralina RESOL",
    "pleaseChoose": "Scegliere prego",
    "invalidCharacters": "Caratteri non validi",
    "chooseLanguage": "Selezionare la lingua",
    "langGerman": "Tedesco",
    "langEnglish": "Inglese",
    "langFrench": "Francese",
    "langItalian": "Italiano",
    "langSpanish": "Spagnolo",
    "langSuomi": "Finlandese",
    "showDiagram": "Visualizza grafico",
    "diagramTitle": "Titolo del grafico",
    "publicLink": "Link pubblico",
    "loadingData": "Caricamento dati in corso, attendere prego",
    "saving": "I dati vengono salvati",
    "yourLiveData": "I tuoi dati in diretta",
    "warningNoLivedata": "Nessun dato in diretta disponibile!",
    "noResults": "La tua selezione non fornisce risultati!",
    "removeAll": "Cancellare tutto",
    "undo": "Annulla",
    "originalNamesValues": "Nomi e valori originali",
    "conversionAvailable": "Conversione disponibile",
    "maxAllowedFilterValues": "Il filtro comprende più valori di quelli consenti! Un datalogger demo può contenere al massimo 10 valori filtro. Durante il salvataggio saranno salvati solo i primi 10 valori filtro.",
    "filterDeleted": "Il filtro è stata eliminato.",
    "showCustomImages": "Immagini personalizzate",
    "imageDeleted": "L’immagine è stata eliminata.",
    "system": "Sistema",
    "autoscaleDescription": "Impostare le dimensioni del sistema in diretta alla resoluzione massima dello schermo.",
    "lastSent": "Ultimo invio",
    "on": "il",
    "language": "Lingua",
    "active": "attivo",
    "inactive": "inattivo",
    "daily": "Giornaliero",
    "weekly": "Settimanale",
    "monthly": "Mensile",
    "settings": "Configurazione generale",
    "online": "Connesso",
    "offline": "Disconnesso",
    "confirmed": "Confermare",
    "notConfirmed": "Non confermato",
    "demo": "Dimostrazione",
    "accessDatalogger": "L’accesso per VBus.net deve essere trovato nell’interfaccia web del tuo datalogger!",
    "loginDatalogger": "Eseguire il login nell’interfaccia web del tuo datalogger e attivare l’accesso su:",
    "settingsDatalogger": "Configurazione / Accesso remoto / Accesso tramite Internet",
    "timezone": "Fuso orario",
    "location": "Localizzazione",
    "geodata": "Coordinate geografiche",
    "search": "Ricercare",
    "change": "Modificare",
    "advancedSettings": "Configurazione avanzata",
    "visuaEnablingVbusnet": "VBus.net si connette a intervalli regolari con il vostro datalogger o modulo di comunicazione per caricare i dati aggiornati. A tale scopo viene utilizzato il volume di dati e la velocità di trasferimento del vostro accesso Internet. Se non desiderate che ciò avvenga, potete disattivare qui il traffico dati. Si fa notare che in tal caso non sarà possibile accedere a nuovi dati di VBus.net e i dati storici non potranno essere sincronizzati nemmeno in un secondo tempo.",
    "userComments": "Commenti dell'utente",
    "adminComments": "Commenti dell'amministratore",
    "accessToken": "Codice di accesso",
    "claimDevice": "Aggiungere un nuovo apparecchio",
    "yes": "Sì",
    "firmware": "Firmware ",
    "serial": "Numero di serie",
    "enabled": "Autorizzato",
    "disabled": "Non autorizzato",
    "userComment": "Commento dell'utente",
    "defaultSettings": "Impostazioni base",
    "controller": "Regolatore",
    "interface": "Interfaccia",
    "technicalData": "Caratteristiche tecniche",
    "privatePerson": "Persona privata",
    "topic": "Tema",
    "yourName": "Il vostro nome",
    "addNoticeSing": "Osservazioni",
    "sendAdditionalInformation": "Send additional information for easier support",
    "Einwilligung": "Consenso relativo alla protezione dei dati",
    "KontaktformularHinweis": "E' possibile annullare l'autorizzazione in qualsiasi momento inviando una e-mail a datenschutz@dvm-cloud.net",
    "send": "Inviare",
    "feedbackText": "General feedback",
    "improvement": {
      "proposal": "Improvement proposal"
    },
    "nameTechnicalSupport": "Assistenza tecnica",
    "question": "Question",
    "hervorragend": "excellent",
    "gut": "good",
    "neutral": "neutral",
    "ausreichend": "sufficient",
    "unzureichend": "insufficient",
    "kinderleicht": "very easy",
    "intuitiv": "intuitive",
    "kompliziert": "complicated",
    "nichtbedienbar": "not operable",
    "unverzichtbar": "indispensable",
    "sehrhilfreich": "very useful",
    "teilweisenuetzlich": "partly useful",
    "unbrauchbar": "useless",
    "sendResetPasswordInstructions": "Richiedere istruzioni per cambiare la password",
    "nameTechnicalSupportTime": "Lun - Ven 08:00 - 16:30 ore ",
    "feedbackName": "Feedback",
    "feedback": "Modulo di feedback",
    "ImpressumAngaben": "Informazioni conformi all'articolo 5 della legge tedesca sui media",
    "Streitschlichtung": "Risoluzione della controversia",
    "StreitschlichtungText": "Non partecipiamo ne siamo obbligati a partecipare ai procedimenti di risoluzione delle controversie dinanzi ad un collegio arbitrale del consumatore.",
    "StreitschlichtungAllgemein": "Foro competente per la risoluzione della controversie",
    "nameDataloggerKomm": "Datalogger / Modulo di comunicazione",
    "nameRouter": "Router",
    "Versionsvergleich": "BASIC e PRO a confronto",
    "year": "Anni",
    "passwordConfirmation": "Confermare la password",
    "Pflichtfelder": "I campi contrassegnati da asterisco devono essere compilati",
    "resendConfirmationInstuctions": "Reinviare la e-mail di conferma",
    "back": "Indietro",
    "years": "Anni",
    "basicLiveSystemText": "Con l’Editor di sistema Live potete visualizzare i dati selezionati del vostro impianto in modo molto semplice in un’immagine di sistema. Trascinare i dati mediante drag&drop nella posizione desiderata e inserire le icone predefinite (per es. serbatoio e valvole) nell’immagine di sistema. I dati vengono aggiornati automaticamente ogni 5 minuti senza che si debba caricare di nuovo la pagina.",
    "basicConnectionText": "VBus.net consente l’accesso semplice e sicuro al vostro sistema, senza che sia necessario installare software aggiuntivi o disporre di nozioni sulla rete.",
    "freeBasicFunctions": "Funzioni di base gratuite",
    "basicLiveDataText": "I dati in diretta del vostro sistema possono essere visualizzati in una tabella chiara. In questo modo è possibile avere sott’occhio tutti i valori di misura aggiornati.",
    "basicDiagrammeText": "I dati salvati possono essere visualizzati sotto forma di un grafico personalizzabile.",
    "GeplanteDownloadsText": "A scadenze regolari e in modo automatico riceverete i dati salvati del vostro impianto via e-mail. Potete selezionare i periodi di tempo e stabilire, ad esempio, anche altri destinatari.",
    "ReporteText": "Riceverete via e-mail report personalizzati sullo stato dell’impianto solare.",
    "GeraetTeilenText": "Condividete il vostro impianto con altri utenti di VBus.net  ̶  ad esempio con il vostro installatore o consulente in materia di energia a scopo d’informazione e assistenza tecnica.",
    "SystemEditorText": "Utilizzate molte altre funzioni di editing per configurare il vostro sistema Live in modo personalizzato e integrare vostre immagini dei componenti e grafici del sistema.",
    "SicherungText": "Con pochi clic potete salvare le impostazioni di visualizzazione di VBus.net in una copia di backup e ripristinarle all’occorrenza.",
    "FehlerprotokollText": "Questa funzione offre una panoramica degli errori che si sono verificati nel vostro sistema e permette di effettuare una ricerca errori in modo semplice e veloce.",
    "BenachrichtigungenText": "Con questa funzione potete inviare notifiche e-mail liberamente definibili a una cerchia di destinatari prefissata, ad es. in caso di messaggi di errore.",
    "ParametrisierenText1": "Parametrizzate la vostra centralina in modo molto semplice anche a distanza tramite il vostro browser Internet. Salvate le configurazioni direttamente in VBus.net e caricatela sulla vostra centralina all’occorrenza.",
    "basicText1": "Provate VBus.net. La versione base è gratuita e subito dopo aver effettuato l’accesso avrete a disposizione un datalogger dimostrativo. Presentate i dati in un sistema “live” o visualizzate i dati salvati in un grafico.",
    "basicConnection": "Accesso sicuro al vostro sistema",
    "basicLiveSystem": "Sistemi live",
    "basicLiveData": "Visualizzare i dati in diretta",
    "basicDiagramme": "Grafici",
    "proFunctions": "Funzioni PRO",
    "logout": "Disconnetersi",
    "Funktionsbeschreibung": "Descrizione funzione",
    "kommunikationsmodulKM2": "Modulo di comunicazione KM2",
    "dataloggerDL2": "Datalogger DL2",
    "dataloggerDL3": "Datalogger DL3",
    "Informations": "Informazioni",
    "tools": "Strumenti",
    "rechtliches": "Note legali",
    "products": "Prodotti",
    "preferences": "Configurazione",
    "menutype": "Navigazione rapida",
    "Visualisieren": "Visualizzazione",
    "Ueberwachen": "Monitoraggio",
    "vbusnetRequirements": "Requisiti per VBus.net",
    "vbusnetRequirementsText": "Per l’utilizzo di VBus.net è necessario che la vostra centralina RESOL sia connessa all’interfaccia dati VBus® solamente tramite un datalogger (DL2/DL3) o a Internet tramite un modulo di comunicazione (KM2). Non sono necessarie complesse installazioni di software.",
    "VisualisierenText1": "Con le possibilità di visualizzazione di VBus.net avete sempre sott’occhio i dati del vostro impianto.",
    "VisualisierenText2": "Visualizzate i vostri dati in un grafico di sistema chiaro o create dei diagrammi per presentare i dati del vostro impianto nel corso del giorno, della settimana o del mese.",
    "UeberwachenText1": "Monitorate il vostro impianto in modo molto semplice mediante report automatici e notifiche.",
    "UeberwachenText2": "Ottenete informazioni via e-mail a scadenze regolari sullo stato del vostro impianto solare. Sarete così sempre al corrente della situazione e potrete reagire immediatamente in caso di problemi. Individuate i problemi con tempestività    Create dei report e inviateli al vostro installatore per l’analisi degli errori.",
    "ParametrisierenText2": "Attualmente sono supportate le seguenti centraline solari e di sistema:",
    "proAccountRequired": "È necessario un accesso PRO!",
    "inviteFriend": "Condividere l'apparecchio",
    "Parametrisieren": "Parametrizzazione",
    "indexPortal": "Il portale per il vostro impianto di riscaldamento e solare",
    "schnittstellenadapter": "L’adattatore di interfaccia VBus®/LAN non è compatibile con VBus.net!",
    "km2": {
      "title": "Soluzione economica per l'accesso a distanza per i regolatori RESOL",
      "text": "Il modulo di comunicazione KM2 è l'interfaccia perfetta tra una centralina solare o di riscaldamento RESOL e Internet. Per collegare una centralina RESOL al portale di visualizzazione VBus.net bastano pochi passaggi. Il modulo di comunicazione è stato progettato per tutte le centraline equipaggiate con RESOL VBus® e consente un accesso semplice e sicuro ai dati di sistema attraverso VBus.net.L'accesso remoto alla tua centralina RESOL è possibile anche attraverso il software di configurazione RPT."
    },
    "dl2": {
      "title": "Datalogger DL2 – Accesso remoto alle centraline e registrazione dati integrata",
      "text": "Il Datalogger DL2 è l’interfaccia tra una centralina RESOL e internet e serve, inoltre, per la registrazione degli impianti. Il DL2 permette l’accesso ai dati d’impianto su www.VBus.net."
    },
    "dl3": {
      "title": "Datalogger DL3 – Registrazione dati con funzionalità aggiuntive",
      "text": "Il Datalogger DL3 serve per la registrazione di massimo 6 centraline RESOL e permette la visualizzazione su www.VBus.net e la parametrizzazione RPT. Il display grafico rende visibile le centraline connesse, tutte le impostazioni importanti possono essere modificate direttamente al DL3. Gli ingressi di sonde e a impulsi possono misurare temperature e registrarle, anche senza centralina. Il DL3 contiene inoltre la funzionalità BACnet per il traffic dati conforme al protocollo BACnet e quindi è ideale per l’integrazione nel sistema di gestione centralizzata dell’edificio."
    },
    "profitPro": "Sfruttate i vantaggi di tutte le funzioni VBus.net e ordinate il vostro accesso PRO.",
    "Funktionsvergleich": "Funzioni a confronto",
    "danke": "RESOL vi ringrazia",
    "team": "La vostra equipe RESOL",
    "errorRequired": "__Feld__ è obbligatorio!",
    "errorInvalid": "__Feld__ è errato!",
    "errorNotEqual": "__Feld__ è errato!",
    "collapse": {
      "all": "Chiudere tutti"
    },
    "expand": {
      "all": "Aprire tutti"
    },
    "help": "Aiuto",
    "loading": "Caricamento in corso",
    "data": "Dati",
    "notice": "Indicazione",
    "quickDiagram": "Grafico veloce",
    "quickDownload": "Download veloce",
    "saved": "Salvato",
    "unknow": "Sconosciuto",
    "warning": "Attenzione",
    "upload": "Caricare",
    "uploadCustomImage": "Caricare un'immagine personalizzata",
    "version": "Versione",
    "device": "Apparecchio",
    "own": {
      "name": "Nome personalizzato"
    },
    "getFullVersion": "Versione completa",
    "limitations": "Limitazioni",
    "filter": "Obbligatoiro",
    "addNote": "Indicazioni supplementari",
    "contactAdr": "Indirizzo per corrispondenza (posta cartacea)",
    "loggedInAs": {
      "prefix": "Connesso come",
      "suffix": "Non sei tu?"
    },
    "actions": "Azioni",
    "tip": "CONSIGLIO",
    "info": "Informazione",
    "link": "Link",
    "register": "Creare un account",
    "or": "o",
    "and": "e",
    "rememberMe": "Rimanere connesso",
    "changeMyPassword": "Cambiare la mia password",
    "wrongEmailOrPassword": "E-mail o password errata",
    "newOwnership": "Nuovo apparecchio",
    "alert": "Attenzione",
    "update": "Aggiornamento",
    "comments": "Commenti",
    "videos": "Video",
    "downloads": "Downloads",
    "dokumente": "Documenti",
    "datenblatt": "Scheda tecnica",
    "montageanleitung": "Istruzioni per il montaggio",
    "filtern": "Filtro",
    "type": "Tipo",
    "until": "fino a",
    "datapoint": "Dati",
    "seconds": "Secondi",
    "hours": "Ore",
    "position": "Posizione",
    "move": "Spostare",
    "billingAdr": "Indirizzo di fatturazione",
    "billingAdrAdd": "(se diverso da indirizzo di contatto)",
    "terminateFriend": "Ritirare l'accesso all'apparecchio",
    "myFriends": "I miei apparecchi condivisi",
    "custom": "definito dall'utente",
    "continuous": "in continuo (24h/24)",
    "immediately": "Immediatamente",
    "notificationPeriod": "Periodo di notifica",
    "monitoringPeriod": "Periodo di monitoraggio",
    "latitude": "Latitudine",
    "longitude": "Longitudine",
    "abbreviation": {
      "example": "per esempio"
    },
    "price": "Prezzo",
    "functions": "Funzioni",
    "required": "Obbligatorio",
    "errorReport": "Rapporto errori",
    "permanent": "illimitato",
    "at": "alle",
    "oClock": "ore",
    "unsubscribed": "cancellato",
    "every": "ogni",
    "pixel": "Pixel",
    "lagging": "Caro cliente,<br><br>L'accesso a VBus.net risulta attualmente lento.<br>Faciamo tutto il possibile per risolvere il problema. Chiediamo la Sua comprensione e ci scusiamo per i disagi eventualmente causati.<br><br>La Sua equipe Vbus.net",
    "offset": "Taratura",
    "defaults": "Impostazioni di fabbrica ",
    "deleteAll": "Cancella tutto",
    "mustSelectOneOption": "Dovete selezionare almeno una opzione!",
    "browserNotSupported": "Il tuo browser non è supportato!<br/>Si prega di aggiornare ad una versione corrente. ",
    "uploadErrorFile": "Il file non può essere caricato!",
    "errorSensor": "Sensore guasto",
    "new": "Nuovo",
    "energyOffset": "Offset per valore di energia",
    "weatherData": "I dati meteo della vostra località.",
    "gridLiveSystem": "Funzione griglia per facilitare il posizionamento",
    "dailyEnergyValues": "Riepilogo giornaliero valori energetici",
    "overwriteWarning": "I dati esistenti verranno sovrascritti!",
    "maxFilesize": "Grandezza massima del file",
    "factor": "Fattore",
    "removeConversions": "Cancellare conversione",
    "chooseAltUnit": "Selezionare schermo di visualizzazione alternativo…",
    "content": "Contenuto",
    "additionalContent": "Ulteriori contenuti",
    "choseContent": "Selezionare contenuti",
    "publicLinkDiagrams": "Collegamenti pubblici ai grafici",
    "publicLinkSchemes": "Collegamenti pubblici dei sistemi in diretta",
    "deviceInfo": "Informazioni sull’apparecchio",
    "noEnergyValuesInFilter": "Il filtro selezionato non contiene valori di energia",
    "warningSelectOnValue": "Dovete selezionare almeno un valore del filtro!",
    "heatQuantityDay": "Quantità di calore giornaliero",
    "heatQuantityWeek": "Quantità di calore settimana",
    "heatQuantityMonth": "Quantità di calore mensile",
    "heatQuantityTotal": "Quantità di calore totale",
    "errorMessages": "Messaggio di errore",
    "temperatureValuesIn": "Valori di temperatura in",
    "operator": "Utilizzatore del sistema",
    "systemType": "Tipo di sistema",
    "showLiveSystem": "Visualizza sistema in diretta",
    "confirmationMail": "E-mail di conferma",
    "noConfirmationMailreceived": "Avete ricevuto un'e-mail di conferma ?",
    "backupHintReceivers": "L’e-mail deve essere inviata manualmente a tutti i destinatari.",
    "notificationInterval": "Intervallo di notifica",
    "oneEnergyInFilter": "Il filtro deve contenere almeno un valore di energia!",
    "iUnderstand": "Ho capito.",
    "useCookies": "Questo sito web utilizza i cookies.",
    "whatsNew": "Cosa c’è di nuovo?",
    "nameTelefon": "Telefono: +49 (0) 23 24/96 48-0",
    "nameFax": "Fax: +49 (0) 23 24/96 48-755",
    "nameEmail": "info@dvm-cloud.net",
    "slide1": "Grafici individuali",
    "slide2": "Sistemi in diretta",
    "slide3": "Rapporti automatici via E-Mail",
    "slide4": "Come funziona?",
    "nextSteps": "Prossima tappa",
    "clickHereForMoreInformation": "Cliccate qui per saperne di più..",
    "clickHere": "Cliccate qui..",
    "learnMore": "Più informazioni",
    "firstSteps": "Primi passi in Vbus.net",
    "deviceName": "Nome del dispositivo",
    "forWeatherData": "Per i dati metereologici",
    "dataloggerOrCommunicationModule": "Datalogger DL2 / DL3  o  modulo di comunicazione KM2",
    "downloadComplete": "Download  completato",
    "automaticallyConfirmed": "Il vostro indirizzo e-mail (in \"Il mio profilo\") si attiva automaticamente. I nuovi destinatari dell'e-mail devono prima confermare la ricezione.",
    "downloaded": "scaricato",
    "templates": "Modelli",
    "template": "Modello",
    "addTemplate": "Aggiungere modello",
    "noTemplateAvailable": "Nessun modello é disponibile per questo schema.",
    "templateAdded": "Il modello é stato aggiunto con successo.",
    "channel": "Canale",
    "vbusConnection": "Connessione VBus",
    "optional": "opzionale",
    "unknownError": "Si è verificato un  errore sconosciuto",
    "menuLanguage": "Lingua del menu",
    "reloadPageNow": "Ricaricare la pagina",
    "noDevicesFound": "Nessun dispositivo trovato sul VBus.",
    "Haftungsausschluss": "Dichiarazione di non responsabilità",
    "PrivacyPolicy": "Informativa sulla privacy",
    "TermsOfUse": "Condizioni generali di vendita",
    "Verantwortlich55RStV": "Responsabile per il contenuto secondo § 55 Abs. 2 RStV (Trattato di radiodiffusione dello Stato tedesco)",
    "UmsatzsteuerIdUg": "Numero d’identificazione dell’imposta di cifra d’affari in base a § 27 a Legge sull’imposta di cifra d’affari",
    "VertGeschFuehrer": "Gerente responsabile",
    "DsgvoStart": "Il 25 maggio 2018 entra in vigore un nuovo regolamento di base per la tutela dei dati personali (Datenschutzgrundverordnung, DSGVO).",
    "DsgvoStarted": "Il 25 maggio 2018 è entrato in vigore il nuovo regolamento di base per la tutela dei dati personali (Datenschutzgrundverordnung, DSGVO).",
    "DsgvoText": "Il regolamento DSGVO contiene specifiche prescrizioni e obblighi di informazione relativi all'elaborazione e alla tutela dei dati personali. ",
    "acceptEulaMessage": "Accettare le condizioni di utilizzo e l'informativa sulla privacy",
    "weather": "Meteo",
    "other": "Altro",
    "fullscreen": "Immagine intera",
    "createFilterFirst": "È necessario prima creare un filtro…",
    "deviceFilter": "Filtri per gli apparecchi",
    "filterLisyByOnlineStatus": "Filtrare la lista in base allo stato online",
    "filterLisyByDeviceType": "Filtrare la lista in base al tipo di apparecchio",
    "sorting": "Classificazione",
    "noDataLoaded": "Impossibile caricare i dati, provare a caricare nuovamente la pagina!",
    "showLegend": "Visualizzare la legenda",
    "symbol": "Simbolo",
    "chooseHeatQuantities": "Potete selezionare al massimo 3 quantità di calore",
    "twoFactorAuthentication": "Autentificazione a due fattori (2FA)",
    "faq": "Domande frequenti",
    "copyToClipboard": "Copiare negli appunti",
    "worst": "pessima",
    "bad": "scadente",
    "weak": "debole",
    "good": "buona",
    "strong": "efficace",
    "automaticUpdate": "Aggiornamento automatico in __SECONDS__ secondi",
    "axisSettings": "Impostazioni degli assi",
    "engaged": "On",
    "off": "Off",
    "setup2FA": "Creare l’autentificazione a due fattori",
    "remove2FA": "Eliminare l’autentificazione a due fattori",
    "setupShort2FA": "Creare 2FA",
    "removeShort2FA": "Eliminare 2FA",
    "recovery2FA": "Codici di reset",
    "qr2FA": "Codice QR",
    "authenticator2FA": "Codice autenticatore",
    "code12FA": "I codici di reset possono essere utilizzati per accedere al vostro account VBus.net nel caso in cui non abbiate accesso alla vostra app di autentificazione a due fattori.",
    "code22FA": "Trattate i codici di reset con la stessa cautela che usereste per la vostra password. Vi consigliamo di salvarli in un Password-Manager.",
    "code32FA": "I codici di reset possono essere utilizzati esclusivamente per il primo accesso e perdono la loro validità dopo che è stato effettuato con successo il login.",
    "code42FA": "Salvate i vostri codici di reset o stampateli prima di proseguire con la creazione dell’autenticazione a due fattori.",
    "code52FA": "Se smarrite i codici di reset e non avete più accesso alla vostra app di autentificazione a due fattori, non sarete più in grado di effettuare il login!",
    "print": "Stampa",
    "code62FA": "Scannerizzate il codice a barre con la vostra app Autenticatore. Quindi fate clic su AVANTI.",
    "code72FA": "Immettete il codice della vostra app Autenticatore e fate clic su COMPLETARE.",
    "finish": "Completare",
    "invalid2FA": "Il codice autenticatore immesso non è valido. Riprova.",
    "success2FA": "La tua autentificazione a due fattori è stata creata con successo!",
    "examples": "Aiuto",
    "notPossibleMobile": "Questa funzione non è disponibile su un dispositivo mobile!",
    "dateAndTime": "Data e ora",
    "deviceOverview": "Panoramica degli apparecchi",
    "deviceMap": "Mappa della posizione degli apparecchi",
    "minimumSize": "Dimensione minima",
    "maximumSize": "Dimensione massima",
    "activation": "Attivazione",
    "switchToPro": "Passa adesso all’accesso PRO",
    "documentNotFound": "Purtroppo non è stato possibile trovare sul nostro server il documento indicato.",
    "startPage": "Pagina iniziale",
    "clear": "Resettare",
    "helpAndSupport": "Aiuto & Supporto",
    "fileUpload": "Caricare il file",
    "fileUploadText": "Il file __FILENAME__ viene caricato sul server. Attendere…",
    "unsupportedFileType": "Il tipo di file non è supportato!",
    "invalidCharactersFilename": "Il nome del file non può contenere caratteri speciali o dieresi!",
    "invalidFileSize": "Il file è troppo pesante! (max. 15 MB)",
    "errorLoadData": "Errore durante il caricamento dei dati!",
    "unknownExceptionError": "Errore eccezionale sconosciuto",
    "demoDevice": "Apparecchio dimostrativo",
    "friendDevice": "Apparecchio condiviso",
    "temperatureSensor": "Sonda di temperatura",
    "switch": "esterno",
    "alreadyClaimedDemo": "Hai già aggiunto un datalogger dimostrativo al tuo account utente.",
    "function": "Funzione",
    "convertValue": "Convertire il valore",
    "tokenNotWorking": "Peccato, non ha funzionato. Prova con un altro token/coupon.",
    "divisionByZero": "Divisione per 0!",
    "passwordStrength": "Efficacia della password",
    "chartType": "Tipo di grafico",
    "autoscale": "Scalare automaticamente",
    "time": "Ora",
    "factoryDefault": "Impostazione di fabbrica",
    "initialize": "Inizializzazione",
    "addDataloggerCommunicationModule": "",
    "twoFactorRemovedSuccessful": "",
    "hideLegend": "",
    "warningUnknownLivedata": "",
    "default": "",
    "passwordIsEmail": "",
    "unknownDevice": "",
    "noSettingsAvailable": "",
    "errorLoadImage": "",
    "errorLoadWeather": "",
    "errorLoadLiveSystem": "",
    "weekday": "",
    "createdAt": "",
    "tooltip": "",
    "subtitle": "",
    "lastUpdated": "",
    "preview": "",
    "extendSubscription": "",
    "loginToExtendSubscription": "",
    "orderedSubscription": "",
    "yourAccount": "",
    "unlimited": "",
    "emailAlreadyExists": "",
    "selectDecices": "",
    "description": "",
    "decimals": "",
    "needInvoice": "",
    "proAccount": "",
    "businessAccount": "",
    "convertFilterValue": "",
    "doNotShowAgain": "",
    "toggle": "",
    "numberFormat": "",
    "checkVBusConnection": "",
    "liveDataNotUpToDate": "",
    "news": "",
    "hide": "",
    "archive": "",
    "noNewMessages": "",
    "messages": "",
    "viewArchivedMessages": "",
    "readNow": "",
    "customerOpinions": "",
    "globalErrorTitle": "",
    "globalErrorMessage": "",
    "globalSuccessTitle": "",
    "globalSuccessMessage": "",
    "endOfQuarter": "",
    "lastQuarter": "",
    "licenseText": "",
    "invalidToken": "",
    "selectDay": "",
    "selectCalendarWeek": "",
    "selectMonth": "",
    "selectYear": "",
    "calendarWeek": "",
    "calendarWeekShort": "",
    "selectQuarter": "",
    "dataloggerDL2Plus": "Datalogger DL2 Plus",
    "geodataFormatDecimal": "",
    "geodataFormatSexagesimal": "",
    "noData": "",
    "automaticConversion": ""
  },
  "vbusnet": {
    "email": {
      "confirmText": "Grazie per esservi registrati su VBus.net. Il link qui sotto vi consente di confermare il vostro account:",
      "confirmMyAccount": "Confermare il mio account",
      "requestNewPassword": "Qualcuno ha richiesto un link per cambiare la password. Per cambiare la password, fate clic sul link qui sotto.",
      "changeMyPassword": "Cambiare la password",
      "didNotRequestThisText": "Se non siete stati voi a richiedere il link, non tenete conto di questa e-mail.",
      "passwordWontChangeText": "La vostra password rimane invariata a meno che clicchiate sul seguente link per cambiarla."
    },
    "demo_ownership_description": "Questo datalogger dimostrativo mette a disposizione i dati di un impianto solare termico e di riscaldamento installato all'ovest della Germania. I dati VBus i più interessanti sono:",
    "demo_datalogger": "Il datalogger dimostrativo dispone solamente di possibilità di modifica limitate."
  },
  "visualization": {
    "scheduledDownloadBodyAttachment": "Troverete, in allegato, il vostro download pianificato.",
    "scheduledDownloadBodyNoAttachment": "Questa e-mail non contiene download pianificati. Probabilmente non ci sono dati nel periodo selezionato. ",
    "scheduledDownloadSubjectDaily": "Il vostro download quotidiano pianificato.",
    "scheduledDownloadSubjectWeekly": "Il vostro download settimanale pianificato.",
    "scheduledDownloadSubjectMonthly": "Il vostro download mensile pianificato.",
    "report": "Rapporto",
    "reportConfirmSubject": "Confermate il nuovo rapporto.",
    "scheduledDownload": "Download pianificato",
    "scheduledDonwloadConfirmSubject": "Si prega di confermare il nuovo download pianificato. ",
    "scheduledDownloadConfirmMessage": "Se si desidera rimanere informati sul download programmato, cliccate sul seguente link:",
    "scheduledDownloadUnsubscribe": "Cancellare la ricezione del download pianificato.",
    "reportConfirmMessage": "Se non volete ricevere altre e-mail su questo rapporto, fate clic sul seguente link:",
    "reportUnsubscribe": "Non desidero più ricevere e-mail su questo rapporto",
    "nameImage": "Immagine",
    "nameFilter": "Filtro",
    "nameDiagram": "Grafico",
    "nameScheme": "Sistema",
    "maxCustomerImages": "Consente solo il caricamento di 3 immagini proprie",
    "accepting": {
      "text": {
        "eula": "Accettare l'accordo di licenza per l'utente finale e l'accordo sulla protezione dei dati ",
        "accept": "Accettare adesso"
      }
    },
    "downloadFormatTextTabWin": "Testo (tabulato, Windows)",
    "downloadFormatTextSemWin": "Testo (punto e virgola, Windows)",
    "downloadFormatTextTabLin": "Testo (tabulato, Linux)",
    "downloadFormatTextSemLin": "Testo (punto e virgola,Linux)",
    "downloadFormatVbus": "Protocollo dati Vbus",
    "nameDownload": "Download",
    "nameReport": "Rapporto",
    "addScheduledDownload": "Aggiungere nuovo download pianificato",
    "enabling": {
      "text": {
        "vbusnet": "Autorizzare la visualizzazione con VBus.net",
        "eula": "Attivando quest'opzione accettate che il nostro servizio conservi i vostri dati conformemente all' <a href='/eula'>accordo di licenza per l'utente finale</a> !"
      }
    },
    "allowParameterizationTextPlain": "Autorizzare la configurazione con l'indirizzo Via e il RESOL Parameterization Tool (RPT)",
    "settings": "Configurazione della visualizzazione",
    "allowParameterizationText": "Autorizzare la configurazione con l'indirizzo Via e il <a href='http://www.resol.de/index/software/sprache/en' target='_blank'>RESOL Parameterization Tool (RPT)</a> ",
    "scheduledDownloads": "Downloads pianificati",
    "myImage": "Immagine personale",
    "myFilter": "Filtro personale",
    "myScheme": "Il mio sistema",
    "myDiagram": "Grafico personale",
    "myDownload": "Il mio download",
    "myScheduledDownload": "I miei download pianificati",
    "myReport": "Il mio rapporto",
    "myWeather": "Le mie informazioni metereologiche",
    "downloadButton": "scaricare",
    "saveButton": "salvare",
    "showButton": "visualizzare",
    "reportsSelectPeriod": "Scegliere un periodo di tempo",
    "extendedReportsInfo": "Ricevete informazioni sullo stato del vostro sistema solare regolarmente via e-mail. È possibile ricevere informazioni sul rendimento (sotto forma di grafico) o di messaggi di errore, ecc  per esempio una volta alla settimana.",
    "extendedReportsWeekInfo": "Se si seleziona \"Settimanale\", si riceveranno i dati della <strong> ultima settimana</strong> dal giorno selezionato.",
    "extendedReportsMonthInfo": "Se si seleziona \"mensile\" si riceveranno i dati della <strong>del mese scorso completo </strong>il primo giorno del mese all'orario desiderato.",
    "extendedReportsYearChart": "Vista di insieme dell'anno.",
    "extendedReportsWithYearChart": "Con vista di insieme dell'anno",
    "extendedReportsFilterInfo": "Il grafico sarà creato con i dati selezionati. E inoltre possibile creare un grafico annuale se lo desiderate.",
    "sendReportAfterSave": "Inviare rapporto dopo la registrazione. ",
    "sendScheduledDownloadAfterSave": "Inviare download pianificato dopo la registrazione. ",
    "sendScheduledDownloadNow": "Inviare adesso il download pianificato",
    "sendReportNow": "Inviare adesso il report",
    "sendScheduledDownloadNowDialog": "Desiderate impostare adesso il vostro download pianificato su attivo e riceverlo successivamente per e-mail?",
    "sendReportNowDialog": "Desiderate impostare adesso il vostro report su attivo e riceverlo successivamente per e-mail?",
    "scheduledDownloadSubjectQuarter": ""
  },
  "monitoring": {
    "weeklyReport": "Il vostro rapporto settimanale",
    "monthlyReport": "Il vostro rapporto mensile",
    "notificationConnectMail": "Riceverete e-mails una volta stabilita nuovamente la connessione.",
    "notificationDisconnected": "La connessione al dispositivo è stata interrotta!",
    "notificationStillDisconnected": "La connessione al dispositivo è ancora interrotta!",
    "notificationDisconnectedNoMail": "Non riceverete più e-mails circa l'interruzione della connessione",
    "notificationConnected": "Connessione al dispositivo ristabilita.",
    "errormaskTrue": "La maschera di errore ha rilevato un errore",
    "errormaskFalse": "La maschera di errore non ha rilevato alcun errore",
    "mailer": {
      "warning": {
        "subject": "Avvertimento"
      },
      "error": {
        "subject": "Errore"
      },
      "notificationConfirm": {
        "subject": "Si prega di confermare la nuova notifica."
      },
      "connection": {
        "subject": "Stato della connessione"
      },
      "notification": {
        "message": "Se volete essere informati in futuro circa la seguente notifica, fate clic sul seguente link:",
        "urlText": "Confermate questo indirizzo e-mail.",
        "unsubscribe": "Cancellare la ricezione di e-mail di questa notifica."
      },
      "userText": "Testo dell'utente"
    },
    "thresholdTrue": "Valore limite raggiunto",
    "repealed": "risolto",
    "notification": "Notifica",
    "statusHasChanged": "Lo stato di una delle condizioni della seguente notifica è cambiato.",
    "allConditionsAreFulfilled": "Tutte le condizioni della seguente notifica sono soddisfatte.",
    "notificationConfirmed": "Il vostro indirizzo e-mail è stato confermato con successo.",
    "notificationAlreadyConfirmed": "Il vostro indirizzo e-mail è già stato confermato.",
    "notificationInvalidToken": "Codice di conferma non valido!",
    "timePeriod": "Intervallo di tempo",
    "receiver": "Destinatario",
    "addNewReceiver": "Aggiungere nuovo destinatario",
    "errorOccurred": "Errori verificatisi",
    "errorEliminated": "Errori eliminati",
    "add": {
      "notification": "Aggiungere nuova notifica",
      "action": "Aggiungere nuova azione"
    },
    "notificationConnectionMessage": "La connessione al vostro dispositivo sarà monitorata automaticamente!<br> Se l’apparecchio non è collegato al VBus.net per più di {1} minuti, si riceverà una e-mail informativa circa l'interruzione del collegamento. Sarete informati se la connessione se si è interrotta due volte nelle ultime 24 ore e si riceverà una e-mail non appena la connessione è ristabilita.",
    "errorLog": "Protocollo d'errore",
    "myNotification": "Le mie notifiche",
    "conditions": "Condizioni",
    "addNewCondition": "Aggiungere nuova condizione",
    "selectDatapoint": "Selezionate i dati",
    "actions": "Azioni",
    "allConditionsFulfilled": "tutte le condizioni devono essere soddisfatte",
    "oneConditionFulfilled": "almeno una condizione deve essere soddisfatta",
    "message": "Messaggio",
    "hintNotification": "È necessario aggiungere almeno una condizione e un'azione per salvare una notifica!",
    "edit": {
      "notification": "Modificare notifica"
    },
    "delete": {
      "notification": "Cancellare notifica?"
    },
    "criterion": "Criterio",
    "delay": "Ritardo",
    "trippingTime": "Tempo di intervento",
    "receivers": "Destinatari",
    "numberOfConditions": "Numero di condizioni",
    "allConditionsFulfilled ": "tutte le condizioni devono essere soddisfatte",
    "oneConditionFulfilled ": "almeno una condizione deve essere soddisfatta",
    "addNewTemperatureNotification": "Aggiungere una nuova notifica di temperatura",
    "addNewErrorNotification": "Aggiungere una nuova notifica di errore",
    "overriding": "Superamento alto",
    "lower deviation": "Superamento basso",
    "warning": {
      "value": "Valore di avvertimento"
    },
    "error": {
      "value": "Valore errato"
    },
    "numberOfActions": "Numero di azioni",
    "action": "Azione",
    "relatedActions": "Azioni correlate",
    "threshold": "Soglia",
    "warningThreshold": "Soglia di avvertimento",
    "errorThreshold": "Soglia di errore",
    "absoluteValue": "Valore assoluto",
    "difference": "Differenza",
    "minimum": "Minimo",
    "maximum": "Massimo",
    "greaterOrEqual": "maggiore o uguale a ",
    "lessOrEqual": "minore o uguale a ",
    "greaterThan": "maggiore di",
    "lessThan": "minore di ",
    "unequal": "ineguale",
    "dailyReport": "Il vostro rapporto giornaliero",
    "reportMessageBodyAttachment": "Il vostro rapporto si trova nell'allegato a questa e-mail.",
    "reportMessageBodyNoAttachment": "Questa e-mail non contiene rapporti. Probabilmente non ci sono dati per il periodo scelto.",
    "currentValue": "Valore attuale",
    "condition": "Condizione",
    "disconnectionNotification": "",
    "noDisconnectionNotification": ""
  },
  "account": {
    "emailNewConfirmation": "Confermare nuovo indirizzo e-mail",
    "changeEmailBodyText": "Avete cambiato il vostro indirizzo e-mail. Per convalidare questo indirizzo email, cliccate sul link qui sotto:",
    "activation": {
      "error": "Siamo spiacenti, si è verificato un errore. Si prega di ripetere l'azione."
    },
    "changeEmailSuccessful": "Il nuovo indirizzo di posta elettronica è stato convalidato con successo.",
    "emailNew": "Nuovo indirizzo e-mail",
    "changeEmail": "Cambiare indirizzo e-mail",
    "areYouSure": "Siete sicuri?",
    "username": "Nome utente",
    "cancel": "Eliminare l'account",
    "unhappy": "Non siete soddisfatti?",
    "deleteMyAccount": "Eliminare il mio account",
    "changePassword": "Cambiare la password",
    "create": {
      "user": "Creare un nuovo account"
    },
    "edit": {
      "user": "Modificare l'account"
    },
    "password": {
      "CurrentPasswordMessage": "Abbiamo bisogno della vostra password per confermare le modifiche effettuate"
    },
    "understoodEulMessage": "Ho letto e compreso l'<a href='/eula'>accordo di licenza per l'utente finale</a>.",
    "emailConfimationText": "Un messaggio contenente un link di conferma è stato inviato al vostro indirizzo e-mail. Per attivare l'account, fate clic sul link ricevuto.",
    "passwordNew": "Nuova password",
    "passwordOld": "Vecchia password",
    "passwordNewConfirmation": "Confermare nuova password",
    "userData": "Dati utente",
    "invalid_token": "È stato attivato con successo il vostro account VBus.net. È possibile accedere con i vostri dati di accesso.",
    "emailOrUsername": "E-mail o nome utente",
    "changeEmailInServices": "Se  cambiate il vostro indirizzo e-mail, questo verrà cambiato anche nei seguenti servizi:",
    "changeEmailConfirmation": "Una email di conferma è stata inviata a __EMAIL__. Fate clic sul link nella mail per confermare il nuovo indirizzo.",
    "acceptEulaMessage": "Accettare le condizioni di utilizzo e l'informativa sulla privacy",
    "AcceptEula": "Per poter continuare a utilizzare VBus.net è necessario accettare le nostre condizioni di utilizzo e l'informativa sulla privacy. "
  },
  "order": {
    "yourOrderSubject": "Il vostro ordine presso VBus.net",
    "salesTaxIdentificationNumber": "Numero di partita IVA",
    "positions": "Posizioni",
    "oneYearPro": "1 x accesso VBus.net PRO (1 anno) 39 €",
    "bankDetails": "Coordinate bancarie",
    "paymentDetails": "Vista la modalità di pagamento tramite bonifico bancario, riceverete immediatamente la fattura tramite e-mail. Per effettuare il bonifico vogliate utilizzare le coordinate bancarie che sono indicate ed inserire il numero di fattura e il vostro indirizzo e-mail VBus.net. Questo ci permetterà di identificare il vostro pagamento",
    "activatedAfterPayment": "Dopo aver ricevuto il pagamento il vostro accesso a VBus.net PRO verrà attivato.",
    "upToThreeDays": "Questa operazione può richiedere fino a 3 giorni.",
    "reference": "Causale del pagamento",
    "paymentMethod": "Metodo di pagamento",
    "order": "Ordinazione",
    "confirmation": "Riceverete tra qualche minuto una conferma d'ordine tramite e-mail con le informazioni sul pagamento. Dopo aver ricevuto il pagamento il vostro accesso a VBus.net PRO verrà attivato.",
    "paymentPaypal": "Pagamento tramite Paypal",
    "paymentBankTransfer": "Pagamento tramite bonifico bancario",
    "paymentPerMail": "Fattura per e-mail all’indirizzo",
    "now": "Ordinare adesso",
    "linkAgb": "Si applicano le nostre Condizioni Generali di Vendita CGV",
    "mustConfirm": "Prima dovete confermare l'ordine",
    "VbusVisulizationVor2013": "Ordinare l'accesso a VBus.net per i DL2 prodotti prima del 2013",
    "withCost": "Ordinare qui (a pagamento)",
    "VbusVisulization": "Sì, desidero ordinare il tool di visualizzazione VBus.net",
    "description": "L'acceso alla visualizzazione VBus.net si acquista con un pagamento unico di <b>20 euro (IVA inclusa)</b>.<br/>Una volta effettuato l'ordine riceverete una e-mail di conferma.",
    "umstid": "Numero di partita IVA",
    "billingAdressAdd": "Indirizzo di fatturazione (se diverso dall'indirizzo di corrispondenza)",
    "dl2": {
      "bevor2012": "Acceso VBus.net per i DL2 prodotti prima del 2013",
      "thanks": "Grazie per aver scelto VBus.net. Il vostro accesso è stato attivato. Vi auguriamo buon divertimento con le funzionalità avanzate."
    },
    "vatIncluded": "IVA inclusa",
    "salutaion": "Signor/Signora",
    "thanksForOrder": "Vi ringraziamo per il vostro ordine del",
    "orderDetails": "Dettagli sul vostro ordine:",
    "emailReference": "Nel bonifico, vogliate indicare il vostro indirizzo email VBus.net come causale di pagamento, questo ci permetterà di attribuire il vostro pagamento al vostro ordine.",
    "sendOrder": "Inviare ordine",
    "accountUpdated": "",
    "currentSubscription": "",
    "newSubscription": "",
    "validUntil": "valida fino a"
  },
  "professional": {
    "willExpire": "Il vostro acceso PRO scade tra {1} giorni.",
    "order": {
      "euvat": {
        "explanation": "Confermo che la mia residenza principale è nel paese evocato qui sopra. Questa è la base per calcolare l'IVA (solo in UE)."
      },
      "information": {
        "required": "Informazioni richieste"
      },
      "require": {
        "text": "Il venditore di questo articolo richiede le seguenti informazioni:"
      },
      "received": "Abbiamo ricevuto il vostro pagamento PayPal.",
      "thanks": "Grazie per aver scelto VBus.net PRO. Il vostro accesso VBus.net PRO sarà sbloccato immediatamente. Vi auguriamo buon divertimento con le funzionalità avanzate.",
      "redirect": {
        "wait": "Il vostro ordine verrà inviato a PayPal.",
        "wait2": "Questa operazione può durare qualche secondo."
      }
    },
    "own": {
      "scheme": {
        "images": "Immagini personalizzate di sistema"
      }
    },
    "data": {
      "live": {
        "time": "Archiviazione dei dati"
      }
    },
    "function": {
      "overview": "Vista di insieme di accesso a VBus.net"
    },
    "time": {
      "live": {
        "data": "Aggiornamento dei dati"
      }
    },
    "enhanced": {
      "scheme": {
        "editor": "Editor avanzato di sistema"
      }
    },
    "dl2": {
      "inclusive": "Accesso VBus.net per i DL2 costruiti prima del 2013"
    },
    "error": {
      "protocol": "Protocollo di errore"
    },
    "monitoring": "Notifiche",
    "friendship": {
      "function": "Condividere l'apparecchio"
    },
    "subscription": {
      "name": {
        "basic": "Base",
        "professional": "PRO "
      }
    },
    "subscriptionRequired": "Dovete disporre di un accesso a VBus.net di tipo PRO per realizzare questa azione.",
    "expired": "SCADUTO",
    "extendOneYear": "Prorogare per un anno (a pagamento)"
  },
  "extend": {
    "professional": {
      "account": "Adesso prolungare l'acceso PRO"
    }
  },
  "address": {
    "herr": "Signore",
    "frau": "Signora",
    "billingAddress": "Indirizzo di fatturazione",
    "firma": "Azienda",
    "anrede": "Titolo",
    "vorname": "Nome",
    "nachname": "Cognome",
    "strasse1": "Via 1",
    "strasse2": "Via 2 ",
    "postleitzahl": "Codice di avviamento postale",
    "ort": "Città",
    "plz": "CAP",
    "land": "Paese",
    "businessCustomer": "Cliente impresa",
    "privateCustomer": "Cliente privato",
    "email": "E-mail",
    "telefon": "Telefono",
    "fax": "Fax",
    "internet": "Internet",
    "strasse": "Via ",
    "bundesland": "Provincia",
    "kundennummer": "Numero cliente",
    "webseite": "Sito web",
    "name": {
      "first": "Nome",
      "last": "Cognome"
    },
    "address": "Indirizzo",
    "kunde": "Cliente"
  },
  "backbone": {
    "validation": {
      "required": "è richiesto",
      "email": "deve essere un indirizzo e-mail valido",
      "acceptance": "deve essere accettato",
      "min": "deve essere superiore o uguale a {1}",
      "max": "deve essere inferiore o uguale a {1}",
      "range": "deve essere compreso tra {1} e {2}",
      "length": "deve avere {1} carattere",
      "minLength": "deve avere almeno {1} carattere",
      "maxLength": "deve avere al massimo {1} carattere",
      "rangeLength": "deve essere compreso tra {1} e {2}",
      "oneOf": "deve essere costituito da: {1}",
      "equalTo": "deve essere uguale a {1}",
      "digits": "deve essere solo numeri",
      "number": "deve essere un numero",
      "url": "deve essere un indirizzo valido",
      "inlinePattern": "non valido",
      "matchPasswords": "le password non sono uguali",
      "matchEmail": "Gli indirizzi e-mail non sono identici.",
      "compareWithOriginalEmail": "Il nuovo indirizzo di posta elettronica non deve essere uguale all'indirizzo attuale."
    }
  },
  "errors": {
    "messages": {
      "already_confirmed": "Il vostro account è stato confermato, provate ad effettuare il login",
      "prohibited": {
        "ownership": {
          "one": "1 errore ha impedito a questo dispositivo di essere salvato:",
          "others": "2 errori hanno impedito a questo dispositivo di essere salvato:"
        }
      }
    }
  },
  "passwordWrong": "La password immessa è errata. Controllare i dati immessi!",
  "ownership": {
    "invalidToken": "Codice di accesso non valido.",
    "alreadyClaimed": "Questo apparecchio è già stato aggiunto.",
    "successfully": {
      "created": "L' apparecchio è stato aggiornato correttamente.",
      "deleted": "L'apparecchio è stato eliminato con successo!"
    },
    "alreadyInOwnAccount": "Questo dispositivo era disponibile sul vostro account. Se desiderate ripristinarlo, selezionate il dispositivo corrispondente dall'elenco.<br>Se desiderate aggiungere il dispositivo come Nuovo dispositivo, i dati precedenti non verranno ripristinati.",
    "alreadyInOtherAccount": "Questo dispositivo è già stato aggiunto ad un account!<br>Il dispositivo deve essere rimosso da tutti gli altri account o, se si tratta del vostro dispositivo, deve essere ripristinato.<br>Si prega di prendere in considerazione le istruzioni del manuale utente!",
    "restoreThisDevice": "Ripristinare questo dispositivo",
    "deleteOwnership": "Eliminare l'apparecchio",
    "addAsNew": "Aggiungere come Nuovo dispositivo",
    "confirmText": "Siete sicuri di voler eliminare questo apparecchio?",
    "claim": {
      "online": {
        "message": "Per poter aggiungere un apparecchio, il vostro datalogger o modulo di communicazione KM1 deve essere connesso a Internet."
      }
    },
    "via_tag": "Identificativo VIA",
    "editing": "Modificare l'apparecchio",
    "description": {
      "via_tag": "Immettere un identificativo VIA e salvarlo per poter personalizzare il proprio indirizzo VIA. Una volta salvato l'identificativo VIA, l'indirizzo VIA si potrà usare per accedere ai dati dell'impianto tramite internet.<br/>L'identificativo VIA deve avere almeno 3 caratteri e cominciare con lettera minuscola. Caratteri ammessi: minuscole, numeri e trattini."
    },
    "claimedSuccessful": "Il vostro__PRODUCT-NAME__ è stato aggiunto.",
    "getFirstDataHeader": "interrogazione dati in corso..",
    "getFirstDataSubtext": "Verrà effettuata la connessione. Questo processo può richiedere alcuni minuti ..",
    "dataReceivedSuccessfully": "Interrogazione avvenuta con successo",
    "initSettingsText": "Si prega di inserire le seguenti informazioni nel vostro dispositivo:",
    "claimOwnFriendshipToken": "",
    "adjustTimestamps": "",
    "adjustTimestampsInfo": "",
    "openSettings": ""
  },
  "viatag": {
    "alreadyInUse": "Questo identificativo VIA è già utilizzato"
  },
  "demo": {
    "temperature": {
      "collector": "Temperatura del collettore",
      "storage": {
        "below": "Temperatura del serbatoio (in basso)",
        "above": "Temperatura del serbatoio (in alto)"
      }
    },
    "pump": {
      "speed": "Velocità della pompa solare"
    },
    "valve": {
      "storage": "Valvola del serbatoio"
    },
    "maximum": {
      "count": {
        "exeed": "Il Datalogger dimostrativo non è stato installato. Ogni utente può aggiungere un solo datalogger dimostrativo al massimo!"
      }
    }
  },
  "error": {
    "messages": {
      "not_found": "Non trovato"
    },
    "noData": {
      "aviable": "Nessun dato per le impostazioni selezionate!"
    },
    "tooManyRequests": ""
  },
  "coupon": {
    "claimedSuccessful": "Il vostro buono é stato utilizzato con successo. Il vostro accesso PRO è stato attivato/prolungato di",
    "alreadyClaimed": "Il codice è già stato ulizzato",
    "invalidToken": "Codice del buono non valido",
    "youHaveACoupon": "Avete già un buono? ",
    "code": "Codice del buono",
    "redeemCoupon": "Utilizzate il buono",
    "name": "Buono ",
    "enterCouponCode": "inserite il codice del buono qui",
    "redeemAnotherCoupon": "Utilizzate il buono supplementare",
    "deviceWithTestPro": "Il vostro dispositivo include un buono, testate VBus.net PRO gratuitamente per 30 giorni!",
    "redeemNow": "Utilizzate il buono adesso",
    "redeemLater": "Utilizzate il buono più tardi",
    "redeemLaterText": "È inoltre possibile utilizzare il buono in seguito – il vostro codice: __COUPON__ (potete trovarlo sul   retro del  manuale)."
  },
  "device": {
    "notFound": "L'apparecchio non è stato trovato.",
    "newFirmwareAvailable": "Una nuova versione del firmware __VERSION__ è disponibile!",
    "serial": "Seriale",
    "version": "Versione",
    "build": "Costruito",
    "product": "Prodotto",
    "fw_feed": "Fw alimentazione",
    "firmware_feed": "Firmware alimentazione",
    "newFirmware": "Nuovo firmware disponibile",
    "claimInfoPorts": "Vi preghiamo di notare che il vostro datalogger (DL2/DL3) o modulo di comunicazione (KM2) deve essere connesso a Internet e avere accesso a VBus.net! Al fine di consentire l’accesso al server VBus.net, il datalogger o il modulo di comunicazione deve avere accesso incondizionato alle porte 80 e 1194 / 1195 del router.",
    "claimInfoLed": "Il LED di controllo del funzionamento deve essere verde fisso",
    "claimVbusActivated": "Il server VBus.net deve essere attivo",
    "claimInfoNetwork": "deve essere visualizzato nel menu Rete",
    "claimInfoNoVisualizationSettings": "Per questo apparecchio non esiste alcuna impostazione di visualizzazione."
  },
  "dataProtection": {
    "Einwilligung": "Consenso relativo alla protezione dei dati",
    "EinwilligungWiderruf": "Potete revocare il vostro consenso in qualsiasi momento per <span class=\"nobr\">e-mail</span> all’indirizzo datenschutz@dvm-cloud.net.",
    "EinwilligungText1": "Ho compreso e accetto le URL_NUTZUNG e le URL_DATENSCHUTZ."
  },
  "eula": {
    "acceptWarning": "Dovete prima accettare il nostro accordo di licenza per l'utente finale e per la protezione dei dati per continuare.",
    "agb": "Condizioni di utilizzo",
    "privacyPolicy": "Informativa sulla privacy",
    "reaccept": "Abbiamo cambiato il nostro accordo di licenza per l'utente finale e l'accordo sulla protezione dei dati. Per continuare, è necessario accettare.",
    "name": "Accordo di licenza per l'utente finale e accordo sulla protezione dei dati",
    "acceptText": "Cliccando Iscriversi, accettate la nostra __eula__."
  },
  "filter": {
    "add": "Aggiungere nuovo filtro",
    "showAll": "Visualizzare tutte",
    "edit": "Modificare filtro",
    "name": "Nome del filtro",
    "addToFilter": "Aggiungere a filtro",
    "show": "Visualizzare",
    "mustBeAString": "Deve essere un testo",
    "atLeastOneDatapoint": "È necessario aggiungere almeno un campo dati al filtro!",
    "showUsed": "Solo impostazioni di fabbrica modificate",
    "pleaseSelectDatapoints": "Selezionate i punti dati dalla lista dei vostri dati in diretta.",
    "noFilterData": "Non sono disponibili dati filtro!",
    "changedLiveData": "I vostri dati in diretta sono cambiati dopo la creazione del filtro!",
    "noConversionAvailable": "Nessuna conversione disponibile",
    "conversionError": "Errore nella conversione!",
    "changedLiveDataShowOldValues": "",
    "maxValues": "",
    "datapointNotEditable": ""
  },
  "day": {
    "today": "Oggi",
    "yesterday": "Ieri",
    "lastTwo": "Ultimi 2 giorni",
    "lastSeven": "Ultimi 7 giorni",
    "lastThirty": "Ultimi 30 giorni",
    "currentMonth": "Mese corrente",
    "lastMonth": "Il mese scorso",
    "sa": "Sab",
    "So": "Dom",
    "do": "Gio",
    "Di": "Mar",
    "Mi": "Mer"
  },
  "ademe": {
    "module": "Modulo",
    "filter": {
      "header": "Filtro per moduli",
      "units": "Filtro per unità",
      "allModules": "Tutti i moduli",
      "allUnits": "Tutte le unità"
    },
    "report": {
      "add": "Aggiungere un nuovo rapporto",
      "edit": "Modificare il rapporto",
      "save": "Salvare rapporto"
    },
    "add": {
      "header": "ADEME:"
    },
    "systemType": "Tipo di sistema",
    "systemNumber": "Numero di sistema",
    "value": "Valore",
    "values": "Valori",
    "error": {
      "systemNumberStart": "Il numero di identificazione deve incominciare con IS!",
      "systemNumberLength": "Il numero di identificazione deve avere tra 12 e 14 caratteri !",
      "systemNumberCharacter": "Il numero di identificazione contiene dei caratteri non validi!",
      "systemNumberYear": "Il numero di identificazione non contiene un anno valido!",
      "SystemType": "<br />Si prega di selezionare un tipo di sistema!"
    },
    "hint": {
      "successSaveHeader": "Con successo!",
      "successSaveBody": "I vostri dati sono stati salvati con successo!",
      "warningSaveHeader": "Attenzione!",
      "warningSaveBody": "Avete già salvato i dati sul vostro sistema. Le modifiche possono influenzare il vostro contratto ADEME "
    },
    "select": {
      "systemType": "Selezionare il tipo di installazione"
    },
    "system": "Sistema",
    "units": {
      "Energy": "Energia",
      "Temperature": "Temperatura",
      "CubicMeter": "Metri cubi"
    }
  },
  "sideBar": {
    "filters": "Filtro",
    "images": "Immagini",
    "liveSchemes": "Sistemi in diretta",
    "diagrams": "Grafici",
    "downloads": "Download",
    "reports": "Rapporti",
    "notifications": "Notifiche",
    "visualization": "Visualizzazione",
    "friends": "Condividere l'apparecchio",
    "dashboard": "Cruscotto",
    "parametrization": "Parametrizzazione WebRPT",
    "discovery": "DeviceDiscoveryTool",
    "utilities": "Strumenti",
    "myVBusNet": "Il mio VBus.net",
    "status": "Stato",
    "ademe": "ADEME",
    "monitoring": "Monitoraggio"
  },
  "choose": {
    "download": {
      "format": "Scegliete un formato per il download"
    },
    "system": "Scegliete un sistema",
    "background": {
      "image": "Scegliete un'immagine di sfondo"
    },
    "filter": "Scegliete una selezione di dati",
    "periodOfTime": "Scegliete un intervallo temporale",
    "image": "Selezionate un'immagine",
    "device": "Selezionare un apparecchio"
  },
  "plan": {
    "valid": {
      "until": "Valida fino a"
    },
    "order": {
      "here": "Ordinare qui"
    },
    "days": {
      "left": "Giorni residui"
    },
    "trial": {
      "expired": "IL PERIODO DI PROVA È SCADUTO"
    }
  },
  "subtitle": {
    "myDevices": "I miei apparecchi",
    "myVirtualDevices": ""
  },
  "unit": {
    "add": "+ Aggiungere valore",
    "sub": "- Sottrarre valore",
    "mul": "* Moltiplicare valore",
    "div": "/ Dividere valore",
    "inv": "1/valore (valore reciproco)",
    "calculate": "convertire unità"
  },
  "parameterization": {
    "supportedDevicesText": "Gli apparecchi seguenti possono essere parametrizzati attualmente tramite VBus.net:",
    "rptWebseite": "Se il vostro apparecchio non è ancora supportato da VBus.net, possiamo utilizzare come alternativa anche il nostro strumento di parametrizzazione RPT RESOL. Maggiori informazioni sullo strumento RPT sono reperibili sul nostro sito web:",
    "connectionRptServer": "Connessione al server WebRPT in corso...",
    "connectionRptServerError": "Impossibile stabilire una connessione al server WebRPT!",
    "connectionRptServerRetry": "Controllare nuovamente la connessione...",
    "checkConncectionToDevice": "Verifica possibilità di parametrizzazione",
    "notParameterizable": "Non parametrizzabile",
    "vbusPassword": "Password VBus",
    "passwordHint": "Immettere la password per la manutenzione da remoto (impostazione di fabbrica: vbus).",
    "loadConfig": "Caricare le configurazioni memorizzate:",
    "pleaseEnterVbusPassword": "Immettere la password VBus e poi fare clic su AVANTI…",
    "dataTransmission": "Trasmissione dati in corso…",
    "configurationNotLoadable": "impossibile caricare la configurazione!",
    "deleteConfiguration": "Cancellare questa configurazione?",
    "errorTimeout": "Limite di tempo superato durante la connessione al datalogger/modulo di comunicazione",
    "errorConnection": "Datalogger/modulo di comunicazione non connesso a VBus.net",
    "errorNetwork": "Controllare il cablaggio della rete e/o il datalogger/modulo di comunicazione",
    "wrongVbusPassword": "Password VBus errata!",
    "errorNoResponse": "La centralina non risponde!",
    "errorVbus": "Controllare il cavo VBus e/o la centralina.",
    "errorCode": "Codice di errore",
    "errorLogin": "Sessione WebRPT scaduta!",
    "login": "Effettuare nuovamente il login!",
    "notParametrizable": " non è parametrizzabile.",
    "changedController": "La centralina è cambiata!",
    "withoutConfiguration": "Avvia senza configurazione",
    "brokenConfiguration": "Problema di configurazione",
    "proRequired": "Accesso PRO necessario!",
    "rpt": "Note RPT",
    "start": "Configurare ora",
    "connectionController": "Collegamento al controllore in corso…",
    "noConnectionVBusnet": "Non è stato possibile stabilire il collegamento a VBus.net!",
    "checkStep1": "Verificare i propri DL2/DL3/KM2 ed eventualmente le relative impostazioni di rete e le impostazioni Internet e del firewall.",
    "noConnectionController": "Non è stato possibile stabilire il collegamento al controllore!",
    "checkStep2": "Verificare che il controllore sia attivo e che il cavo VBus sia correttamente collegato.",
    "wrongPassword": "Password VBus non valida!",
    "checkStep3": "Verificare le immissioni e poi fare clic su AVANTI.",
    "controllerNotParameterizable": "Controllore non parametrizzabile!",
    "checkStep4": "Verificare che il controllore supporti la parametrizzazione.",
    "connectionVbusnet": "Connessione a VBus.net",
    "controller": "Centralina",
    "checkVersion": "Verifica della versione",
    "configurable": "Parametrizzabile?",
    "getSupportedDevices": "È in corso la ricerca dei dispositivi supportati…",
    "foundSupportedDevices": "Sono stati trovati i seguenti dispositivi che possono essere parametrizzabili in base alla versione software:",
    "noSupportedDevices": "Non sono stati trovati dispositivi supportati!",
    "configuration": "Configurazione",
    "notAllowed": ""
  },
  "parametrization": {
    "header": "Strumento di parametrizzazione RPT ",
    "supportedDevices": "Le seguenti centraline RESOL  sono supportate:",
    "subHeader": "Software per la parametrizzazione di dispositivi RESOL",
    "downloadFree": "Scaricate il software RPT gratuitamente",
    "rptSoftware": "Software RPT  (Versione 1.9)",
    "licenseNote": "Annotazioni sulla licenza",
    "manualPdf": "Manuale (PDF)",
    "systemRequirements": "Requisiti di sistema: Windows 7,  modalità di compatibilità per Windows 8.1 / 10, Java a 32 bit a partire dalla versione 1.6.",
    "howToStepOne": "Avviate il software RPT sul PC, quindi selezionate <strong> Connettere ... </strong> nel menu <strong> Comunicazione </strong> menu.",
    "howToStepTwo": "Selezionate il dispositivo in uso e inserite il vostro identificativo VIA nel campo <strong>indirizzo URL/ IP</strong>.",
    "howToStepThree": "È possibile trovare l'identificativo VIA nel seguente menu:",
    "howToStepFour": "Inserisci la tua password. Se non è stata modificata la password, tuttavia, è <strong>vbus</strong>.",
    "howToStepFive": "Clicca su <strong>Connettere</strong>. Ora è possibile parametrizzare il vostro dispositivo",
    "deviceNotListed": "Se il vostro dispositivo non è in questa lista, si prega di utilizzare il",
    "rscSoftware": "Software RSC",
    "requiredDevices": "Per poter utilizzare  lo strumento di parametrizzazione  RPT, sono necessari i seguenti dispositivi RESOL:",
    "youNeedDevice": "Non avete ancora un dispositivo RESOL? Clicca <a href=\"http://www.resol.de/\" target=\"_blank\">qui</a> per visitare il nostro sito. "
  },
  "settingsDocumentation": {
    "errorTryAgain": "Siete pregati di  riprovare più tardi. Se il problema persiste, siete pregati di contattare il team di supporto tecnico:  support@resol.de",
    "description": "Il Generatore di Documentazione delle Impostazioni crea un file (PDF) dal vostro file SET.",
    "selectSetFile": "Selezionate il file SET",
    "documentTitle": "Titolo del documento",
    "convertSetFile": "Convertire il file SET",
    "startConversion": "Iniziare la conversione",
    "downloadPdfFile": "Scaricare il file PDF",
    "settingsDocumentationGenerator": "Generatore di  Documentazione delle Impostazioni",
    "optionalTitel": "Titolo opzionale",
    "invalidSetFile": "Formato del file SET non valido",
    "incompatibleSetFile": "Il file fornito è un file SET non compatibile con la RESOL DeltaSol  MX 2.xx. Siete pregati di provare con un'altro file.",
    "convertionFailed": "Conversione fallita",
    "errorConversionTookToLong": "La conversione è durata troppo tempo per terminare.",
    "converting": "Conversione in corso",
    "errorAllowedCharacters": "Nel titolo sono permessi solo i seguenti caratteri : lettere, cifre, trattini(-), spazi ( ) e trattini bassi (_).",
    "pdfFile": "File PDF"
  },
  "passwordSame": "La nuova password è identica alla vecchia!",
  "delete": {
    "entry": {
      "text": "Questo input non può essere cancellato perché è usato nelle seguenti funzioni:",
      "header": "Cancellare input",
      "question": "Desiderate cancellare veramente l'input <span id='myModalName' class='delete_question'></span> ?"
    }
  },
  "unitFamily": {
    "temperature": "Temperatura",
    "volume": "Volume",
    "pressure": "Pressione",
    "power": "Potenza ",
    "energy": "Energia",
    "volumeFlow": "Portata",
    "time": "Ora"
  },
  "deleteAccount": "Tutti i tuoi dati e il tuo accesso VBus.net saranno irrevocabilmente cancellati! Quest’operazione non potrà essere annullata! Per confermare immettere la password corrente.",
  "passwordRequired": "Immetti la tua password corrente!",
  "yesDeleteAccount": "Sì, cancellare tutti dati",
  "topBar": {
    "editProfile": "Il mio profilo",
    "registerHere": "Creare un account gratuito",
    "imprint": "Avviso legale",
    "register": "Creare un account",
    "home": "Pagina iniziale"
  },
  "passwordHackInfo": "Gli specialisti informatici richiedono <b>TIME</b>, per calcolare questa password!",
  "changePasswort": {
    "noToken": "Non è stato trovato alcun token per il reset della password! Si prega di notare che il token di reset è valido solo 1 giorno. Eventualmente richiedere nuovamente il link per il reset della password."
  },
  "twoFactorTokenAlredyExists": "I codici di reset possono essere creati una sola volta.",
  "dataviewer": {
    "title": "Per la visualizzazione dei dati dell'impianto tramite scheda di memoria SD. I dati vengono visualizzati in un grafico progressivo completo . Non è necessario ne un registratore di dati  ne un modulo di comunicazione. Il dispositivo non necessita di essere connesso a Internet. I dati rimarranno privati e le  visualizzazioni non verranno memorizzate."
  },
  "diagram": {
    "add": "Aggiungere nuovo grafico",
    "allow": {
      "public": "Creare un link per visualizzare il grafico"
    },
    "edit": "Modificare grafico",
    "data": "Dati",
    "height": "Altezza",
    "width": "Larghezza",
    "noDataSelected": "Nessun dato selezionato",
    "min": "Min",
    "max": "Max",
    "publicUrlCustomRangeWarning": "L'opzione <strong>Intervallo scelto da voi </strong> non è disponibile per i diagrammi publici."
  },
  "vbus": {
    "deactivateFilter": "Il file del protocollo VBus contiene tutti i valori. La funzione Filtro viene disattivata. ",
    "net": "VBus.net"
  },
  "download": {
    "add": "Aggiungere nuovo download",
    "edit": "Modificare download",
    "noDataForSelectedPeriod": "Non ci sono dati nel periodo selezionato!",
    "forOtherOs": ""
  },
  "tooltip": {
    "filter": {
      "standardvorgabe": "È possibile memorizzare ogni filtro come impostazione standard e utilizzarlo come modello per nuovi filtri. Si può creare un’impostazione standard per ogni apparecchio."
    }
  },
  "default": {
    "filter": {
      "load": {
        "msg": "Caricare impostazioni standard",
        "text": "Utilizzate questo filtro come impostazione predefinita "
      },
      "values": "Impostazioni di fabbrica del filtro ",
      "exists": {
        "text": "Avete già creato un filtro per questo apparecchio."
      },
      "default": {
        "text": "Volete utilizzare questo filtro come impostazione predefinita?",
        "create": "Crea regolazioni predefinite",
        "load1": "Aggiungere regolazioni predefinite alla lista",
        "load2": "Modificare la lista con regolazioni predefinite",
        "load3": "Modificare la lista con regolazioni predefinite e aggiungere valori mancanti"
      }
    },
    "load": "Caricare",
    "default": {
      "notexists": {
        "text": "Non avete impostato una regolazione predefinita per questo apparecchio.",
        "text1": "Volete creare una regolazione predefinita per questo apparecchio?"
      },
      "create": {
        "text": "Create una regolazione predefinita"
      }
    }
  },
  "heating": {
    "systems": "Sistema di riscaldamento"
  },
  "solar": {
    "systems": "Sistemi solari",
    "collectors": "Collettori",
    "storages": "Serbatoi",
    "collector": "Colettore",
    "system": "Sistema solare"
  },
  "image": {
    "add": "Aggiungere nuova immagine",
    "name": "Nome dell'immagine",
    "validMimeType": "L'immagine deve avere il formato .jpg, .jpeg, .png o .gif",
    "edit": "Modificare immagine",
    "maxFilesize": "Grandezza massima del file",
    "delete": "Cancellare l’immagine?"
  },
  "scheme": {
    "allow": {
      "public": "Creare link per visualizzare il sistema"
    },
    "setDatapoints": "Posizionare i dati",
    "add": "Aggiungere nuovo sistema",
    "edit": "Modificare schema",
    "publicUrl": "Create un link pubblico per visualizzare il vostro sistema in diretta, anche quando non siete connessi a VBus.net. Potete condividere questo link anche con le persone non registrate. È possibile includere questo link nel vostro sito web per visualizzare in diretta il vostro sistema."
  },
  "reports": {
    "dotDayOfMonth": "giorno del mese",
    "dotDay": ".giorno ogni",
    "dotMonth": ".mese alle"
  },
  "please": {
    "wait": "Attendere prego..."
  },
  "parameterizationsettings": {
    "translation": "Impostazioni della configurazione",
    "makeShureNotDefaultPasswordText": "Accertatevi che la password per la configurazione della centralina nell'interfaccia web del datalogger non sia la password di default 'vbus'.",
    "changePasswordText": "Per cambiare la password, fate clic sul seguente link:"
  },
  "claim": {
    "howToFindToken": "Come trovare il codice di accesso / Token"
  },
  "index": {
    "claimANewDevice": "Aggiungere un apparecchio",
    "editThisInformation": "Modificare questa informazione",
    "welcomeToVBusnet": "Benvenuti a VBus.net!",
    "youNotHaveADataloggerYet": "Non avete ancora un dispositivo? Fate clic qui per aggiungere un datalogger dimostrativo al vostro account...",
    "noVideo": "Non si vede il video? Provate le seguenti alternative",
    "videoDownload": "Scaricare il video",
    "orOn": "oppure",
    "ifYouDoNotHaveADataloggerYet": "Se volete provare VBus.net ma non avete alcun dispositivo, potete aggiungere un datalogger dimostrativo al vostro account nel seguente modo:",
    "list": {
      "logInToVBusNet": "Connettersi a VBus.net",
      "addADemonstationLogger": "Aggiungere un datalogger dimostrativo all'account",
      "activateOptionDatalogger": "Attivare la relativa opzione nel datalogger",
      "getActivationToken": "Annotare il codice di accesso",
      "claimLoggerWhithToken": "Immettere il codice di accesso per aggiungere un datalogger"
    },
    "download": {
      "datasheet": "Sacricare qui la<br />scheda tecnica del VBus.net !",
      "manual": "Sacricare qui le<br />istruzioni del VBus.net !"
    },
    "text1": "VBus.net è un'offerta di servizi web della <a href=“http://www.resol.com“>RESOL</a> che consente l'accesso al proprio dispositivo RESOL in pocchi clic, ovunque ci si trovi.",
    "text3": "VBus.net riguarda i dati della centralina RESOL impiegata. Per accedere a tali dati si deve aggiungere il vostro dispositivo all'account effettuando le quattro semplici operazioni seguenti:",
    "noVideoPlaybackText": "Il browser impiegato non consente la visualizzazione del video. Scaricate il video qui sotto.",
    "general": {
      "register": "Provatelo  gratuitamente e senza impegno "
    },
    "howto": {
      "question": "Volete sapere come funziona? "
    },
    "customer": {
      "examples": "Volete vedere come i nostri clienti utilizzano VBus.net? "
    },
    "title": "Visualizzate i dati del vostro sistema",
    "text2": " Visualizzate le temperature del sistema , create sistemi personalizzati e grafici gratuitamente.",
    "liveSystemExample": "",
    "createNewVirtualDevice": ""
  },
  "show": {
    "liveData": "Visualizzare i dati in diretta"
  },
  "friendship": {
    "createToken": "Creare codice di accesso",
    "createdFriendships": "Codice di accesso creato",
    "createAccessTokenText": "<b>condividete i dati con altri utenti VBus ...</b><br/> <br>Create un nuovo codice di accesso (token) per l'utente VBus.net per consentirgli di accedere ai vostri dati. Potrà creare grafici, sistemi in diretta, etc. utilizzando i dati del vostro sistema. <br/><br/>Si può aggiungere il codice di accesso come un nuovo apparecchio nell'account VBus.net <b>I miei apparecchi <i class=\"fa fa-angle-right\"></i>Aggiungete un apparecchio</b>. Basta dargli il codice di accesso.<br/><br/> Comunque, è possibile revocare l'accesso in qualsiasi momento.",
    "featureNotAvailable": ""
  },
  "feedbackForm": {
    "thankYou": "Grazie per la vostra risposta.",
    "yourOpinion": "Il vostro parere è importante per noi!",
    "helpText": "Volete aiutarci a migliorare VBus.net o avete idee, desideri e proposte? Compilate semplicemente il nostro modulo di feedback.",
    "assessmentText": "Valutate i seguenti punti:",
    "scopeOfFunctions": "Funzioni",
    "userFriendliness": "Semplicità d'uso",
    "use": "Utilità",
    "response": "Il vostro feedback è in corso di elaborazione con il numero _ID_.",
    "yourSatisfaction": "La vostra soddifazione"
  },
  "imprint": {
    "chief": "Gerente rappresentante legale",
    "court": "Tribunale commerciale",
    "registration": {
      "number": "Numero di registrazione "
    },
    "vat": "Numero di partita IVA in base al paragrafo § 27a della Legge sulla partita IVA",
    "poweredBy": "Powered by",
    "technic": {
      "design": "Tecnica & Design internet"
    }
  },
  "sales": {
    "tax": {
      "act": "(Umsatzsteuergesetz in tedesco)"
    }
  },
  "howto": {
    "vbusdotnet": "VBus.net offre la possibilità di visualizzare dati in diretta del vostro sistema. Consente anche di creare grafici dei dati registrati durante un intervallo scelto e di scaricarli.",
    "storageDuration": "I vostri dati rimarranno salvati per 90 giorni (versione “Base”) o un anno (versione “PRO”).",
    "liveData": "Visualizzate i dati in diretta del vostro sistema.",
    "filter": "Create selezioni di dati per usarle ulteriormente nei vostri download, sistemi in diretta e grafici. Potete modificare i nomi di default dei dati e scegliere un colore per ogni linea dei vostri diagrammi.",
    "images": "Memorizzate le immagini dei sistemi per usarle negli schemi in diretta. Potete scegliere un’immagine tra quelle proposte o caricarne una vostra.",
    "downloads": "Scaricate i dati di sistema in vari formati per un intervallo selezionato. Potete salvare i download per usarli ulteriormente o eseguire download veloci per un uso immediato. Per limitare il quantitativo di dati da scaricare potete utilizzare il filtro creato in precedenza (vedi sotto).",
    "liveSchemes": "Visualizzate i dati in diretta sullo schema del vostro sistema. Potete posizionare i dati (nome e valore) trascinandoli semplicemente nel posto desiderato sull’immagine di destra. La registrazione della posizione sullo schema avviene automaticamente. Per utilizzare questa funzione dovete aver creato in precedenza il filtro e l'immagine di sfondo (vedi sopra).",
    "diagrams": "Visualizzate il grafico con i vostri dati nell'intervallo di tempo scelto. Utilizzate un filtro personalizzato (vedi qui sopra).",
    "question": "Come funziona?",
    "friends": "Invitate altri utenti VBus.net per consentire loro di accedere al sistema. Potranno creare grafici, sistemi in diretta, etc.",
    "monitoringGeneral": "Con il monitoraggio VBus.net potete accedere al registro degli errori dove sono salvati gli eventuali errori . È inoltre possibile accedere alle notifiche che vi consentono di sorvegliare qualsiasi parametro del sistema ed essere informati via e-mail.",
    "monitoringNotification": "Con le notifiche si possono selezionare e monitorare diversi parametri di sistema, come ad esempio le temperature, le quantità di calore o la tabella degli errori. È possibile impostarne i limiti e confrontarli con vari criteri con i dati in diretta del vostro sistema. Se si presentano le condizioni per un allarme, sarete informati  via e-mail. Nel caso di  disconnessione riceverete automaticamente una notifica via e-mail. Potrete inoltre, essere informati se il collegamento è stato ripristinato (in caso di interruzione del collegamento).",
    "monitoringErrorlog": "La registrazione degli errori fornisce una panoramica degli errori verificatisi nel vostro sistema. L'errore con la data e l'ora vengono registrati e, se supportato dal regolatore, indicato sia il modulo sia il sensore. Questo può risultare molto utile come, per esempio, nella ricerca guasti.",
    "reports": "Ricevete i I dati memorizzati sul vostro sistema regolarmente e automaticamente via e-mail. È possibile impostare un periodo di tempo e limitare i dati utilizzando un filtro predefinito (vedi sopra). È possibile inoltre, specificare i destinatari e-mail dei rapporti.",
    "backup": "Creare un backup di tutte le impostazioni di visualizzazione .",
    "extendedReports": "Ricevete informazioni sullo stato del vostro sistema solare regolarmente via e-mail. È possibile ricevere informazioni sul rendimento (sotto forma di grafico) o di messaggi di errore, ecc  per esempio una volta alla settimana.",
    "conversionsAndArithmeticOperations": "Conversione e calcolo dei dati",
    "parametrization": ""
  },
  "links": {
    "didNotReceiveConfirmationInstructions": "Non avete ricevuto conferma della registrazione?",
    "didNotReceiveUnlockInstructions": "Non avete ricevuto instruzioni per sbloccare l'account?"
  },
  "customer": {
    "examples": "Esempi dei nostri clienti "
  },
  "dashboard": {
    "proSubscriptionSchemeEditor": "Editor avanzato di sistema",
    "testProSubscription": "Provate gratuitamente VBus.net PRO per 30 giorni!",
    "proSubscriptionLiveData": "Aggiornamento dati ogni minuto",
    "proSubscriptionWeatherDashboard": "Informazioni metereologiche sul vostro cruscotto",
    "proSubscriptionErrorLog": "Protocolli di notifiche di errore del vostro sistema",
    "proSubscriptionReporting": "Criteri definibili dall'utente per notifiche via e-mail",
    "proSubscriptionFriendship": "Condividete i diritti di accesso, per esempio, con l'installatore, per fornirgli informazioni sullo stato del sistema.",
    "proSubscriptionEnable": "Si,vorrei provare l'accesso PRO",
    "proSubscriptionDoNotRemember": "No, non ricordarmelo.",
    "textClaimDemoQuestion": "Non disponete ancora  del datalogger o del modulo di  comunicazione?",
    "textClaimDemo1": "Desiderate comunque informarvi sulle possibilità di VBus.net? ",
    "textClaimDemo2": "Quindi  aggiungete un datalogger dimostrativo al vostro account.",
    "claimDemo": "Aggiungere  datalogger dimostrativo adesso ",
    "textClaimOwnQuestion": "Possedete già un Datalogger o  un modulo di comunicazione?",
    "textClaimOwn1": "Si prega di aggiungere il vostro  dispositivo al vostro account.",
    "claimOwn": "Aggiungi il tuo dispositivo adesso",
    "noDiagramAvailable": "È necessario creare almeno un grafico per poterlo visualizzare sulla videata principale . ",
    "noLiveSystemAvailable": "È necessario creare almeno un sistema in diretta per poterlo visualizzare sulla videata principale . ",
    "noWeatherAvailable": "È necessario innanzitutto impostare una posizione per il dispositivo per poterlo visualizzare. ",
    "demoVisualisierung": "Visualizzazione dimostrativa",
    "ownVisualisierung": "Visualizzare il proprio dispositivo",
    "chooseComponent": "Selezionare un componente del dashboard",
    "addComponent": "Aggiungere un nuovo componente",
    "editComponent": "Modificare componente",
    "changeBackgroundColor": "Modificare il colore di sfondo",
    "deleteAllComponents": "Cancellare tutti i componenti",
    "addComponentInfo": "Aggiungere nuovi componenti al dashboard",
    "notAvailableInFullscreen": "Non disponibile in modalità a schermo intero!",
    "reloadComponent": "Caricare nuovamente i componenti",
    "deleteSelectedComponents": "Cancellare tutti i componenti selezionati",
    "deselectAll": "Deseleziona tutto",
    "noImageAvailable": "",
    "notAllowedForSubscription": "",
    "removeThisComponent": "",
    "removeSelectedComponents": "",
    "load": "",
    "loadFromOtherDevice": "",
    "loadFromOtherDeviceInfo": "",
    "settings": "",
    "itemBorderTyp": "",
    "itemBorderNone": "",
    "itemBorder": "",
    "itemBorderShadow": "",
    "lockItems": "",
    "deleteQuestion": "",
    "delete": ""
  },
  "images": {
    "clickOnImageText": "Fate clic sull'immagine da selezionare.",
    "currentImage": "Immagine attuale"
  },
  "enter": {
    "name": {
      "diagram": "Inserite un nome per il grafico",
      "filter": "Inserite un nome per il filtro",
      "scheme": "Inserite un nome per lo schema",
      "image": "Inserite un nome per l'immagine"
    },
    "vbus": {
      "password": "Immettere la password VBus e poi fare clic su AVANTI…"
    }
  },
  "prepare": {
    "download": "Preparazione dei dati in corso. Questa operazione può richiedere alcuni minuti. Attendere prego…"
  },
  "access": {
    "denied": "Accesso negato"
  },
  "data": {
    "filter": "Filtri",
    "transmission": {
      "running": "Trasmissione dati in corso…"
    }
  },
  "genral": {
    "to": "Fino a"
  },
  "unselect": {
    "all": "Deselezionare tutto"
  },
  "my": {
    "account": "Il mio account",
    "diagrams": "I miei grafici",
    "downloads": "I miei download",
    "schemes": "Le mie schermate di dati in diretta",
    "devices": "I miei apparecchi",
    "friends": "Utenti con accesso ai miei apparecchi",
    "reports": "I miei rapporti"
  },
  "limitationText": {
    "noConfiguration": "Non consente la configurazione del datalogger",
    "only90days": "Sono disponibili solo i dati registrati negli ultimi 90 giorni",
    "onlyDemoDatalogger": "Consente solo l'accesso al datalogger dimostrativo"
  },
  "info": {
    "smallerLogInterval": "VBus.net non supporta gli intervalli di registrazione piccoli immessi nel datalogger.",
    "logInterval": "VBus.net memorizza i dati registrati dal vostro datalogger RESOL ad intervalli di almeno 5 minuti.",
    "clickToDelete": "Eliminare: <i class=\"fa fa-trash-o clickToDelete\"></i>",
    "clickToEdit": "Modificare: <i class=\"fa fa-edit clickToEdit\"></i> ",
    "clickToMove": "Spostare: <i class=\"fa fa-arrows-v clickToMove\"></i>"
  },
  "modal": {
    "info": {
      "filter": "Se desiderate visualizzare solo alcuni dati del vostro sistema, potete creare un <a class='link' href='/vbus/add-selector'>filtro</a> personalizzato. Questo filtro sarà poi proposto nella lista e potrà essere selezionato per la visualizzazione dei dati."
    }
  },
  "discover": {
    "deviceDiscovery": "Device Discovery",
    "deviceDiscoveryWizard": "Device Discovery Wizard"
  },
  "unlocks": {
    "resendUnlockInstructions": "Riinviare le istruzioni per sbloccare l'account"
  },
  "activerecord": {
    "errors": {
      "models": {
        "ownership": {
          "attributes": {
            "name": {
              "too_short": "è troppo corta (minimo richiesto: 6 caratteri)"
            }
          }
        }
      }
    }
  },
  "forward": {
    "toWebinterfaceOfDatalogger": "Reindirizzamento verso l'interfaccia web del datalogger in corso…",
    "notAllowedToAccessOwnership": "Non avete accesso a questo apparecchio.",
    "textForwardedToWebInterface": "Se questo fosse il vostro dispositivo, sareste reindirizzati automaticamente verso l'interfaccia web del datalogger in pochi istanti. Il datalogger dimostrativo non consente questa operazione. Grazie della vostra comprensione.",
    "textLoginOtherCredentials": "Ricordate che i dati di accesso all'interfaccia web del vostro dispositivo sono diversi dai dati di accesso all'account VBus.net.",
    "textYouWillBeForwarded": "Sarete reindirizzati verso l'interfaccia web del vostro dispositivo entro qualche minuto. Se ciò non succede, fate clic sul seguente link.",
    "datenloggerLink": "Interfaccia del dispositivo"
  },
  "paypal": {
    "buy": {
      "now": "Pagare ora"
    },
    "order": {
      "text": "Osservare che questa operazione può durare alcuni giorni.",
      "error": "Si è verificato un errore durante la trasmissione via Paypal. Si prega di contattare il nostro servizio di assistenza tecnica se non è stato attivato il servizio addizionale che avete acquistato."
    }
  },
  "invalid": {
    "via_tag": "L'identificativo VIA deve essere di almeno 3 caratteri e deve iniziare con una lettera minuscola. Caratteri consentiti: minuscole, numeri, trattini e trattini bassi."
  },
  "incorrect": {
    "failure": {
      "already_activated": "Non è possibile utilizzare questo identificativo VIA. Si prega di sceglierne un altro"
    }
  },
  "selected": {
    "dataFields": "Campi dati selezionati"
  },
  "legend": {
    "description": "Legenda",
    "layout": {
      "align": "Disposizione",
      "horizontal": "Orizzontale",
      "vertical": "Verticale"
    },
    "position": {
      "horizontal": "Posizione orizzontale",
      "vertical": "Posizione verticale",
      "left": "A sinistra",
      "central": "In centro",
      "right": "A destra",
      "top": "In alto",
      "bottom": "In basso"
    }
  },
  "datapoint": {
    "selectedOne": "Dato selezionato",
    "selectedMore": "Dati selezionati"
  },
  "information": {
    "minOneOwnership": "Per utilizzare le funzionalità di visualizzazione, è necessario disporre di almeno un apparecchio o di datalogger dimostrativo nel vostro account."
  },
  "tip": {
    "location": "Se si specifica la geo localizzazione del vostro dispositivo è possibile ottenere informazioni meteo. Inserite le coordinate della vostra località o cercate la località."
  },
  "messages": {
    "tryGeodata": "Inserite le coordinate geografiche"
  },
  "get": {
    "professional": {
      "account": "Ottenete l'accesso PRO ora ..."
    }
  },
  "one": {
    "year": {
      "vbus": {
        "professional": "1 anno VBus.net PRO"
      }
    }
  },
  "register": {
    "subscribe": {
      "newsletter": "Voglio iscrivermi alla newsletter RESOL."
    },
    "free": "Creare un account gratuito"
  },
  "homepage": {
    "greetingText": "Il portale Internet per un facile e sicuro accesso ai vostri dati",
    "simpleText": "Semplice accesso in due operazioni:",
    "registerText": "<a href=\"#register\">Creare un account</a> gratuito su VBus.net",
    "addDataloggerText": "Aggiungere il vostro dispositivo a VBus.net",
    "initationText": "In VBus.net ci sono tutti i dettagli del vostro apparecchio RESOL. Esso fornisce dati in diretta del sistema, le impostazioni dei filtri personalizzati, e molto altro ancora.",
    "dataViewerHeader": "Integrato in Vbus.net – il VBus Data Viewer.",
    "dataViewerInfo": "Visualizza i dati registrati sulla memoria SD con VBus Data Viewer."
  },
  "errorLog": {
    "thankYou": "Grazie per l'invio del rapporto di errori.",
    "ticketNumberText": "Il vostro ticket ha il seguente numero:"
  },
  "rerrorReport": {
    "helpText": "Aiutateci a migliorare il funzionamento di VBus.net: comunicateci ogni errore verificatosi durante l'uso di VBus.net."
  },
  "friendshipToken": {
    "typeOfUse": "Uso",
    "useText": "Inserite qui un nome per identificare il codice di accesso ulteriormente. Così potrete sapere con chi avete condiviso il vostro apparecchio."
  },
  "cookies": {
    "name": "Cookies",
    "useVBusnet": "Per poter usare VBus.net si devono abilitare i cookies.",
    "description1": "I cookies sono piccoli file di testo che vengono salvati sul vostro computer da una pagina web. I cookies memorizzano informazioni circa la vostra ultima visita di tale pagina web, la vostra lingua preferita ed altre impostazioni.",
    "description2": "VBus.net utilizza cookies esclusivamente per memorizzare la lingua impostata e dati sul vostro account.",
    "furtherInformation": "Troverete maggiori informazioni sui Cookies e sulla loro gestione su",
    "disclaimerExternalLinks": "Si prega di osservare che non ci assumiamo alcuna responsabilità per il contenuto di siti web esterni.",
    "privacyPolicy": "Ulteriori informazioni sui cookie e sul loro utilizzo sono reperibili nel nostro"
  },
  "subscribe": {
    "maintenance": "Sì, vorrei essere informato sui lavori di manutenzione via e-mail."
  },
  "title": {
    "help": "Aiuto"
  },
  "original": {
    "names": "Nome di origine",
    "value": "Valore originale"
  },
  "cookie": {
    "acceptText": "Regolamenti sui cookie"
  },
  "viaTag": {
    "useDefaultPassword": "Il vostro dispositivo è accessibile con la password standard!",
    "ChangePasswordText": "Per ragioni di sicurezza, è consigliato cambiare la password del dispositivo."
  },
  "lineChart": {
    "diagram": "Grafico valori assoluti"
  },
  "barChart": {
    "diagram": "Istogramma (rapporto giornaliero)"
  },
  "werbung": {
    "textDatenlogger": "Maggiori informazioni sui nostri datalogger / i nostri moduli?",
    "textKommunikationsmodul": "Avete già scoperto il nostro modulo di comunicazione? ",
    "textSolarregler": "Conoscete già i nostri regolatori solari e di sistema ?",
    "textHeizungsregler": "Volete informarvi sulla nostra famiglia di controllori di riscaldamento?"
  },
  "notice": {
    "dataloggerTimeout": "Questo dispositivo non fornisce più dati in diretta da alcuni minuti...",
    "dataloggerInitialze": "Inizializzazione",
    "dataloggerInitialzeText": "Questa operazione potrebbe richiedere alcuni minuti affinché  il dispositivo venga inizializzato.",
    "dataloggerInitialzed": "Il dispositivo è stato inizializzato. Ora potete iniziare la visualizzazione"
  },
  "nextStep": {
    "step2": "Se volete creare un <b>sistema in diretta</b> avete bisogno di una  __IMAGE__.",
    "step3": "Potete adesso creare un  __DIAGRAM__ o  un __LIVESYSTEM__.",
    "step4": "Eseguite un  __DOWNLOAD__ dei vostri  dati per elaborarli  o analizzarli manualmente.",
    "step1": "Create prima un __FILTER__ per poter creare un <b>grafico</ b> o <b> sistema in diretta </ b>. <br/> A <b> download </ b> può anche essere ottimizzato per mezzo di un filtro."
  },
  "support": {
    "noDatafromDevice": "Il vostro dispositivo non contiene dati !",
    "pleaseCheck": "Vogliate consultare il manuale del vostro dispositivo e verificare i seguenti punti:",
    "checkPowerSupply": "Alimentazione elettrica del Router e del Datalogger/modulo di comunicazione",
    "checkInternetConnection": "Connessione internet",
    "checkConncectionToDevice": "Connessione del router al Datalogger/modulo di comunicazione",
    "checkManual": "Per maggiori informazioni consultate le istruzioni d’uso del vostro apparecchio.",
    "hintIntranet": "Per le reti aziendali: Le porte 1194 e 1195 sono bloccate dal vostro firewall. Si prega di contattare l'amministratore di sistema.",
    "allowAccessToAccount": "",
    "token": "",
    "needHelp": "",
    "tokenRemove": "",
    "tokenCreate": "",
    "extended": ""
  },
  "areaChart": {
    "diagram": "Grafico ad area"
  },
  "userFeedback": {
    "helpUs": "",
    "takeTheSurvey": "",
    "question1": "",
    "question2": "",
    "question3": "",
    "question4": "",
    "question5": "",
    "question6": "",
    "question7": "",
    "question8": "",
    "question9": "",
    "question10": "",
    "question11": "",
    "question12": "",
    "question13": "",
    "submit": "",
    "simple": "",
    "complicated": "",
    "veryHelpful": "",
    "redundant": "",
    "notUsed": "",
    "excellent": "",
    "insufficient": "",
    "veryEasy": "",
    "extremelyComplex": "",
    "veryGood": "",
    "veryBad": "",
    "indispensable": "",
    "useless": "",
    "dontKnowYet": "",
    "price": "",
    "noAdditionalValue": "",
    "other": "",
    "daily": "",
    "weekly": "",
    "monthly": "",
    "lessThanMonth": "",
    "quietSure": "",
    "certainlyNot": "",
    "backToDashboard": "Torna al dashboard",
    "answerAllQuestions": "Rispondere a tutte le domande contrassegnate con <i class=\"fa fa-times\" aria-hidden=\"true\"></i>!",
    "extendedPro": "Il vostro accesso PRO è stato prolungato per 30 giorni."
  },
  "dashboardMessage": {
    "changeViaTag": "Per motivi tecnici, l'estensione dell’identificatore via è stata cambiata da <kbd>.via.vbus.net</kbd> a <kbd>.vbus.io</kbd>.  Modificate i vostri segnalibri, se necessario.<br><br>(Esempio: mydl2.via.vbus.net -> mydl2.vbus.io). Non sono necessarie ulteriori modifiche."
  },
  "config": {
    "startWithout": "Avvia senza configurazione",
    "empty": "vuoto",
    "notLoadable": "non caricabile"
  },
  "check": {
    "completed": "Verifica conclusa…"
  },
  "waiting": {
    "running": {
      "tasks": "I processi in corso vengono terminati..."
    }
  },
  "dsgvo": {
    "Nutzungsbedingungen": "Ho letto, compreso e accettato le <a href=\"#register\" class=\"open-terms-of-use\">condizioni di utilizzo</a>.",
    "Datenschutzerklaerung": "Ho letto, compreso e accettato <a href=\"#register\" class=\"open-privacy-policy\">l'informativa sulla privacy</a>."
  },
  "pro": {
    "validUntil": "Accesso PRO valido fino al"
  },
  "channel": {
    "no": "N.canale"
  },
  "location": {
    "notFound": "Impossibile individuare la posizione!"
  },
  "faq": {
    "q1": "Come posso aggiungere un apparecchio a VBus.net?",
    "a1": "Connettiti a VBus.net. Apri la voce di menu I miei apparecchi e clicca Aggiungere un nuovo apparecchio. Immetti il codice di accesso/token del tuo apparecchio.",
    "q2": "Come posso creare un report per il supporto tecnico?",
    "a2_1": "Effettua il login nell’interfaccia web del KM2 e nel menu Stato -> Rapporto di supporto clicca su Scaricare.",
    "a2_2": "Salva il file e invialo a __EMAIL__.",
    "a2_3": "Richiama l’indirizzo IP del datalogger nel browser ed effettua il login nell’interfaccia web.",
    "a2_4": "Richiama l’URL http://[IP DELL’APPARECCHIO]/dlx/support",
    "a2_5": "Apparirà il link \"Fare clic qui per creare e scaricare un resoconto di supporto”, con cui può essere eseguito il download.",
    "q3": "Il mio apparecchio è offline, cosa posso fare?",
    "a3": "Verifica se il tuo apparecchio è connesso a Internet. Se anche altri apparecchi nella stessa rete non dovessero essere connessi a Internet, può trattarsi di un problema nella connessione Internet. Al fine di consentire l’accesso al server VBus.net, l’apparecchio deve avere accesso incondizionato alle porte 80 e 1194 / 1195 del router e non deve essere bloccato da un firewall.",
    "q4": "Devo pagare per utilizzare VBus.net?",
    "a4": "VBus.net è gratuito nella versione base. Puoi visualizzare il tuo sistema e ricevere i dati in diretta ogni 5 minuti. La versione PRO costa 39 € all’anno e oltre alle funzioni base offre molte possibilità per il monitoraggio e funzioni avanzate nella visualizzazione. Inoltre comprende la parametrizzazione tramite WebRPT e i dati in diretta vengono aggiornati ogni minuto.",
    "q5": "Che differenze ci sono fra VBus.net Basic e PRO?",
    "a5": "Qui trovi un confronto tra le diverse versioni VBus.net: __VERSIONSVERGLEICH__",
    "q6": "VBus.net supporta l’adattatore di interfaccia VBus®/LAN?",
    "a6": "No, per connettere la tua centralina al server VBus.net è necessario un modulo di comunicazione KM2, un datalogger DL2 o un datalogger DL3.",
    "q7": "I miei diagrammi vengono visualizzati in modo errato, cosa posso fare?",
    "a7": "Verifica se il fuso orario impostato nel menu I miei apparecchi è corretto e se la posizione dell’apparecchio è quella giusta. Verifica anche il fuso orario sul tuo stesso apparecchio.",
    "q8": "Qual è la password per la parametrizzazione?",
    "a8": "vbus",
    "title": "Risposte alle vostre domande frequenti",
    "hints": "Assicuratevi di utilizzare sempre un browser aggiornato. Qualora sorgessero dei problemi, utilizzate un altro browser.",
    "notFound": "La vostra domanda non ha ancora avuto risposta? Contattateci all’indirizzo __LINK__.",
    "q9": "In un diagramma si trovano scritte non utilizzate sull’asse Y.",
    "a9": "Il filtro utilizzato in questo diagramma deve essere ancora salvato.",
    "q10": "",
    "a10": "",
    "q11": "",
    "a11": ""
  },
  "createImageFirst": "È necessario prima creare un’immagine…",
  "professinal": {
    "expiredOn": "Accesso Pro scaduto il __VALID_UNTIL__!",
    "expireInfo": ""
  },
  "validation": {
    "positiveNumber": "numero positivo"
  },
  "reset": {
    "allEntries": "Resettare tutti gli input"
  },
  "fileSizeToBig": "Il file è troppo pesante!",
  "controllerVersionChanged": "",
  "cantLoadConfigurations": "",
  "dl3NotSupported": "",
  "change": {
    "modulename": ""
  },
  "email": {
    "doNotReply": ""
  },
  "discoveryTool": {
    "title": "",
    "text": ""
  },
  "group": {
    "create": "",
    "edit": "",
    "delete": "",
    "deleteGroup": "",
    "neDeviceDelete": ""
  },
  "filterValue": {
    "add": "",
    "sub": "",
    "mul": "",
    "div": "",
    "conversionWithFilter": "",
    "linkedTo": ""
  },
  "errorSendingEmails": "",
  "errorSendingEmailConfirm": "",
  "confirmEmailServices": "",
  "keyboard": {
    "capsLockActive": ""
  },
  "firmware": {
    "title": "",
    "available": "",
    "downloadText": "",
    "deviceInstall": "",
    "acceptText": "",
    "alreadyAccepted": "",
    "activateAutomaticUpdate": ""
  }
}



// WEBPACK FOOTER //
// ./src/locales/mtf/it/index.js